<ngx-spinner class="custom-spinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
  <!--begin::Toolbar container-->
  <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
    <!--begin::Page title-->
    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
      <!--begin::Title-->
      <div class="d-flex align-items-center">
        <h1 class="page-heading">
          <svg width="36" height="38" viewBox="0 0 36 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_373_934)">
              <path
                d="M4.60489 6.04201H8.77521C9.1081 6.04201 9.38048 5.76959 9.38048 5.43673V1.26638C9.38048 1.02433 9.23522 0.800305 9.00522 0.709573C8.78127 0.612708 8.521 0.667162 8.34549 0.836657L4.18119 5.00701C4.00564 5.18249 3.95118 5.44279 4.04801 5.66674C4.13882 5.89675 4.36276 6.04201 4.60489 6.04201Z"
                fill="#265D91" />
              <path
                d="M12.2618 21.9129V18.9894C12.2618 17.9881 13.0763 17.1736 14.0776 17.1736H14.8236L14.2934 16.6434C13.9505 16.3017 13.7614 15.846 13.7614 15.3607C13.7614 14.8754 13.9505 14.4197 14.2946 14.0769L16.3634 12.008C16.6719 11.68 17.1472 11.4778 17.6431 11.4778C18.1301 11.4778 18.587 11.6664 18.9287 12.008L19.4589 12.5383V11.7923C19.4589 10.791 20.2734 9.97647 21.2747 9.97647H23.3385V1.26677C23.3385 0.933843 23.0722 0.661499 22.7332 0.661499H10.486C10.5522 0.851977 10.5914 1.05502 10.5914 1.26677V5.43691C10.5914 6.43821 9.77686 7.25273 8.77556 7.25273H4.60542C4.39378 7.25273 4.19081 7.21343 4 7.14648V25.6473C4 25.9802 4.27234 26.2526 4.60528 26.2526H13.9076C13.8127 26.0304 13.7614 25.7902 13.7614 25.5416C13.7614 25.0563 13.9505 24.6006 14.2946 24.2578L14.823 23.7287H14.0776C13.0763 23.7287 12.2618 22.9142 12.2618 21.9129ZM10.6599 21.5943H7.63357C7.29902 21.5943 7.0283 21.3236 7.0283 20.989C7.0283 20.6545 7.29902 20.3838 7.63357 20.3838H10.6599C10.9945 20.3838 11.2652 20.6545 11.2652 20.989C11.2652 21.3236 10.9945 21.5943 10.6599 21.5943ZM10.6599 17.9627H7.63357C7.29902 17.9627 7.0283 17.692 7.0283 17.3574C7.0283 17.0228 7.29902 16.7521 7.63357 16.7521H10.6599C10.9945 16.7521 11.2652 17.0228 11.2652 17.3574C11.2652 17.692 10.9945 17.9627 10.6599 17.9627ZM10.6599 14.331H7.63357C7.29902 14.331 7.0283 14.0603 7.0283 13.7257C7.0283 13.3912 7.29902 13.1205 7.63357 13.1205H10.6599C10.9945 13.1205 11.2652 13.3912 11.2652 13.7257C11.2652 14.0603 10.9945 14.331 10.6599 14.331ZM10.6599 10.6994H7.63357C7.29902 10.6994 7.0283 10.4287 7.0283 10.0941C7.0283 9.75954 7.29902 9.48882 7.63357 9.48882H10.6599C10.9945 9.48882 11.2652 9.75954 11.2652 10.0941C11.2652 10.4287 10.9945 10.6994 10.6599 10.6994Z"
                fill="#265D91" />
              <path
                d="M31.3948 18.384H29.0706C28.9617 18.0572 28.8285 17.7364 28.6772 17.4337L30.3175 15.7874C30.5596 15.5514 30.5596 15.17 30.3175 14.934L28.2535 12.8639C28.0174 12.6279 27.6361 12.6279 27.4 12.8639L25.7537 14.5103C25.445 14.3529 25.1303 14.2258 24.8034 14.1168V11.7926C24.8034 11.4537 24.531 11.1873 24.1982 11.1873H21.2747C20.9418 11.1873 20.6694 11.4537 20.6694 11.7926V14.1168C20.3426 14.2258 20.0278 14.3529 19.7191 14.5103L18.0728 12.8639C17.9578 12.7489 17.8064 12.6884 17.643 12.6884C17.4856 12.6884 17.3283 12.7489 17.2193 12.8639L15.1493 14.934C14.9132 15.17 14.9132 15.5514 15.1493 15.7874L16.7956 17.4337C16.6382 17.7364 16.5111 18.0572 16.4022 18.384H14.0779C13.739 18.384 13.4727 18.6564 13.4727 18.9893V21.9128C13.4727 22.2457 13.739 22.5181 14.0779 22.5181H16.4022C16.5111 22.8449 16.6382 23.1597 16.7956 23.4684L15.1493 25.1147C14.9132 25.3508 14.9132 25.7321 15.1493 25.9682L17.2193 28.0321C17.4554 28.2742 17.8367 28.2742 18.0728 28.0321L19.7191 26.3918C20.0278 26.5431 20.3426 26.6763 20.6694 26.7853V29.1095C20.6694 29.4424 20.9418 29.7148 21.2747 29.7148H24.1982C24.531 29.7148 24.8034 29.4424 24.8034 29.1095V26.7853C25.1303 26.6763 25.445 26.5431 25.7537 26.3918L27.4 28.0382C27.509 28.1471 27.6664 28.2137 27.8237 28.2137C27.9871 28.2137 28.1385 28.1471 28.2535 28.0382L30.3175 25.9682C30.5596 25.7321 30.5596 25.3508 30.3175 25.1147L28.6772 23.4684C28.8285 23.1597 28.9617 22.8449 29.0706 22.5181H31.3948C31.7278 22.5181 32.0001 22.2457 32.0001 21.9128V18.9893C32.0001 18.6564 31.7278 18.384 31.3948 18.384ZM22.7334 24.3097C20.6088 24.3097 18.8778 22.5786 18.8778 20.448C18.8778 18.3235 20.6088 16.5925 22.7334 16.5925C24.8639 16.5925 26.595 18.3235 26.595 20.448C26.595 22.5786 24.8639 24.3097 22.7334 24.3097Z"
                fill="#265D91" />
            </g>
            <defs>
              <filter id="filter0_d_373_934" x="0" y="0.661499" width="36" height="37.0533" filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha" />
                <feOffset dy="4" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_373_934" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_373_934" result="shape" />
              </filter>
            </defs>
          </svg>
          Modifier profile
        </h1>
      </div>
      <!--end::Title-->
      <!--begin::Breadcrumb-->
      <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">
          <a class="text-muted" routerLink="/">Accueil</a>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <!--end::Item-->
        <!--begin::Item-->
        <li class="breadcrumb-item text-muted">
          <a class="text-muted" routerLink="/acceuil/candidats/list-candidat">Liste des candidats</a>
        </li>
        <li class="breadcrumb-item">
          <span class="bullet bg-gray-400 w-5px h-2px"></span>
        </li>
        <li class="breadcrumb-item text-muted">
          <a class="text-muted">Modifier profil</a>
        </li>
        <!--end::Item-->
      </ul>
      <!--end::Breadcrumb-->
    </div>
    <!--end::Page title-->
    <!--begin::Actions-->

    <!--end::Actions-->
  </div>
  <!--end::Toolbar container-->
</div>
<div id="kt_app_content" class="app-content flex-column-fluid">
  <!--begin::Content container-->
  <div id="kt_app_content_container" class="app-container container-fluid">
    <div class="pt-4 mb-6 mb-xl-9" *ngIf="selectedCandidate">
      <!--begin::Card header-->
      <div class="content border-0">
        <!--begin::Card title-->
        <form [formGroup]="candidateForm">
          <div class="card-title flex-column">
            <div class="card pb-10 pt-10 mt-10">
              <div class="row">
                <div class="section_img text-center" *ngIf="selectedCandidate">
                  <div class="photo_img">
                    <input type="file" hidden id="imageUpload" accept=".png, .jpg, .jpeg, .jfif,.avif" #fileInput
                      (change)="uploadImage($event)" style="display: none" />
                    <img *ngIf="
                        fileName == '' &&
                        selectedCandidate?.image_url != 'avatar.png' &&
                        selectedCandidate.image_url != 'undefined' &&
                        selectedCandidate.image_url != 'null'
                      " src="{{
                        url +
                          '/User/file/gallery_users/' +
                          selectedCandidate?.image_url
                      }}" class="img-profile" alt="" />
                    <img *ngIf="fileName != ''" [src]="selectedImage" class="img-profile" alt="" />
                    <img *ngIf="
                        (!fileName || (fileName && fileName == '')) &&
                        (!selectedCandidate?.image_url ||
                          (selectedCandidate?.image_url &&
                            (selectedCandidate?.image_url == 'avatar.png' ||
                              selectedCandidate.image_url == 'undefined' ||
                              selectedCandidate.image_url == 'null')))
                      " class="table-img" src="/assets/media/logos/logo-avatar.jpg" alt="" width="75px" />

                    <!-- <div *ngIf="isImageError" class="error-message">
                      Format fichier non compatible !
                    </div> -->
                  </div>
                  <div class="nom-profil text-center mt-5 mb-5">
                    {{ selectedCandidate?.first_name }} {{ selectedCandidate?.last_name }}
                   

                  </div>
                  <div class="btns">
                    <a class="changer cursor-pointer" (click)="fileInput.click()">
                      <svg width="15" height="12" viewBox="0 0 15 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M4.5 0C3.86232 0 3.33333 0.544093 3.33333 1.19999V2.05713H1.16667C0.528982 2.05713 0 2.60123 0 3.25713V10.8C0 11.4559 0.528982 11.9999 1.16667 11.9999H12.1667C12.2329 12.0009 12.2987 11.9883 12.3602 11.9629C12.4217 11.9375 12.4776 11.8998 12.5248 11.8519C12.572 11.8041 12.6095 11.747 12.635 11.6842C12.6606 11.6213 12.6738 11.5538 12.6738 11.4857C12.6738 11.4175 12.6606 11.35 12.635 11.2872C12.6095 11.2243 12.572 11.1673 12.5248 11.1194C12.4776 11.0716 12.4217 11.0338 12.3602 11.0084C12.2987 10.983 12.2329 10.9704 12.1667 10.9714H1.16667C1.06568 10.9714 1 10.9038 1 10.8V3.25713C1 3.15326 1.06568 3.0857 1.16667 3.0857H3.83333C3.96594 3.08569 4.09311 3.0315 4.18687 2.93506C4.28064 2.83861 4.33332 2.70781 4.33333 2.57142V1.19999C4.33333 1.09613 4.39902 1.02857 4.5 1.02857H10.5C10.601 1.02857 10.6667 1.09613 10.6667 1.19999V2.57142C10.6667 2.70781 10.7194 2.83861 10.8131 2.93506C10.9069 3.0315 11.0341 3.08569 11.1667 3.0857H13.8333C13.9343 3.0857 14 3.15326 14 3.25713V10.8C14 10.9038 13.9343 10.9714 13.8333 10.9714C13.7671 10.9704 13.7013 10.983 13.6398 11.0084C13.5783 11.0338 13.5224 11.0716 13.4752 11.1194C13.428 11.1673 13.3905 11.2243 13.365 11.2872C13.3394 11.35 13.3262 11.4175 13.3262 11.4857C13.3262 11.5538 13.3394 11.6213 13.365 11.6842C13.3905 11.747 13.428 11.8041 13.4752 11.8519C13.5224 11.8998 13.5783 11.9375 13.6398 11.9629C13.7013 11.9883 13.7671 12.0009 13.8333 11.9999C14.471 11.9999 15 11.4559 15 10.8V3.25713C15 2.60123 14.471 2.05713 13.8333 2.05713H11.6667V1.19999C11.6667 0.544093 11.1377 0 10.5 0H4.5ZM7.5 3.59998C5.7526 3.59998 4.32292 5.06332 4.32292 6.85711C4.32292 8.65091 5.7526 10.1142 7.5 10.1142C9.2474 10.1142 10.6771 8.65091 10.6771 6.85711C10.6771 5.06332 9.2474 3.59998 7.5 3.59998ZM7.5 4.62855C8.70894 4.62855 9.67708 5.62124 9.67708 6.85711C9.67708 8.09298 8.70894 9.08568 7.5 9.08568C6.29106 9.08568 5.32292 8.09298 5.32292 6.85711C5.32292 5.62124 6.29106 4.62855 7.5 4.62855Z"
                          fill="#265D91" />
                      </svg>
                      Changer la photo
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-10">
                <div class="actions-profil">
                  <a (click)="navigateToProfilCandidat(idCandidat)" class="annuler">
                    <i class="fa-solid fa-xmark iconeXmark"></i>
                  Annuler</a>
                  <a (click)="navigateToCvCandidat(idCandidat)" class="visualiser"><svg width="20" height="13"
                      viewBox="0 0 20 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M18.8697 5.79453C18.7094 5.57412 14.682 0.584961 9.53251 0.584961C4.38305 0.584961 0.37569 5.59416 0.195359 5.79453C-0.0651196 6.11512 -0.0651196 6.55593 0.195359 6.87652C0.355653 7.09692 4.38305 12.0861 9.53251 12.0861C14.682 12.0861 18.6893 7.07688 18.8697 6.87652C19.1101 6.55593 19.1101 6.11512 18.8697 5.79453ZM9.53251 10.3429C6.14629 10.3429 3.18084 7.53773 2.05878 6.33552C3.18084 5.13331 6.16633 2.32816 9.53251 2.32816C12.8987 2.32816 15.8842 5.13331 17.0062 6.33552C15.8842 7.53773 12.9187 10.3429 9.53251 10.3429Z"
                        fill="white" />
                      <path
                        d="M9.53353 8.98039C10.9942 8.98039 12.1784 7.79625 12.1784 6.33553C12.1784 4.87482 10.9942 3.69067 9.53353 3.69067C8.07282 3.69067 6.88867 4.87482 6.88867 6.33553C6.88867 7.79625 8.07282 8.98039 9.53353 8.98039Z"
                        fill="white" />
                    </svg>
                    Visualiser</a>
        
                      <button  class="download dropdown-toggle telecherger"
                      type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true"
                      aria-expanded="false">
                      <svg width="15" height="15"
                        viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.70019 11.2752C7.13239 11.6339 7.56459 11.4187 7.70866 11.2752L12.0306 6.9709C12.3188 6.68394 12.3188 6.25351 12.0306 5.96655C11.7425 5.6796 11.3103 5.6796 11.0222 5.96655L7.92476 9.05133V0.729598C7.92476 0.299163 7.63663 0.012207 7.20443 0.012207C6.77223 0.012207 6.4841 0.299163 6.4841 0.729598V9.05133L3.38667 5.96655C3.09854 5.6796 2.66634 5.6796 2.37821 5.96655C2.09008 6.25351 2.09008 6.68394 2.37821 6.9709L6.70019 11.2752Z"
                          fill="white" />
                        <path
                          d="M13.6863 11.4905C13.2541 11.4905 12.966 11.7774 12.966 12.2079V12.9253H1.44066V12.2079C1.44066 11.7774 1.15253 11.4905 0.720331 11.4905C0.288132 11.4905 0 11.7774 0 12.2079V13.6427C0 14.0731 0.288132 14.36 0.720331 14.36H13.6863C14.1185 14.36 14.4066 14.0731 14.4066 13.6427V12.2079C14.4066 11.7774 14.1185 11.4905 13.6863 11.4905Z"
                          fill="white" />
                      </svg>

                      Télécharger
                  </button>
                      <div class="dropdown-menu " aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item " (click)="downloadCV(cvTypeEnum.WEGESTU, 1)">PDF</a>
                        <a class="dropdown-item " (click)="downloadCV(cvTypeEnum.WEGESTU, 2)">PDF Anonyme</a>
                        <!-- <a class="dropdown-item " (click)="exportCvWordWegest()">Word</a> -->
                        <!-- <a class="dropdown-item " (click)="exportCvAnonymeWord()">Word Anonyme</a> -->
                      </div>
                </div>
            </div>
            <!--begin::Accordion-->
            <div class="update mb-10 mt-10">
              <div class="accordion" id="kt_accordion_1">
                <div class="accordion-item">
                  <h2 class="accordion-header" id="kt_accordion_1_header_1">
                    <button class="accordion-button fw-semibold" type="button" data-bs-toggle="collapse"
                      data-bs-target="#kt_accordion_1_body_1" aria-expanded="true"
                      aria-controls="kt_accordion_1_body_1">
                      <svg width="28" height="21" viewBox="0 0 28 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M22.6697 4.72363C25.1832 4.72363 27.2155 6.76578 27.2155 9.29581C27.2155 11.8237 25.1832 13.8642 22.6697 13.8642C20.1554 13.8642 18.1252 11.8237 18.1252 9.29581C18.1252 6.76578 20.1554 4.72363 22.6697 4.72363ZM19.2004 0.00822979C16.8237 -0.0809834 14.6889 0.552918 13.0443 2.03365C11.4005 0.552569 9.2653 -0.0809834 6.89033 0.00822979C4.51363 0.096746 2.39126 0.941135 1.23981 2.24971C1.16531 2.33335 1.12615 2.44033 1.12407 2.5529V4.57309L0.414771 5.30108C0.0918249 5.63145 0 5.81475 0 6.25943V19.4368C0 20.2934 0.57174 20.8092 1.18021 20.8092H24.9088C25.5186 20.8092 26.0911 20.292 26.0911 19.4368V16.1175C26.0911 14.6273 24.0481 14.6273 24.0481 16.1175V18.0704C22.8374 17.1232 21.1859 16.4367 19.2836 16.3262C17.1106 16.2008 14.7987 16.8127 13.0443 18.3917C11.29 16.8127 8.97839 16.2008 6.80578 16.3262C4.90345 16.437 3.25199 17.1232 2.04128 18.0704V2.78499C2.96854 1.80469 4.82548 1.00456 6.85984 0.886422C7.12111 0.870043 7.38514 0.86621 7.65022 0.871785C9.49781 0.91918 11.3645 1.51614 12.7193 2.87908C12.8981 3.06064 13.1902 3.06064 13.369 2.87908C14.9196 1.32203 17.1359 0.765148 19.2292 0.886422C21.2649 1.00456 23.1201 1.80504 24.0477 2.78499V4.12249C23.6073 4.00261 23.1468 3.93361 22.669 3.93361C19.7292 3.93361 17.3393 6.33853 17.3393 9.29511C17.3393 12.2517 19.7288 14.6549 22.669 14.6549C25.6091 14.6549 28 12.2517 28 9.29511C28 7.16619 26.7567 5.32931 24.9646 4.46366V2.5522C24.9646 2.43964 24.9227 2.333 24.8489 2.24901C23.6984 0.941135 21.5761 0.096746 19.2004 0.00822979Z"
                          fill="#265D91" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M13.0377 4.35503C12.7848 4.36061 12.5828 4.56935 12.5862 4.8234V15.7883C12.5665 16.4232 13.5229 16.4232 13.5031 15.7883V4.8234C13.5069 4.56378 13.2955 4.3512 13.0377 4.35503Z"
                          fill="#265D91" />
                        <path
                          d="M22.1068 8.20117C21.4963 8.23184 21.5437 9.15394 22.1536 9.12327H22.5704V12.1959C22.5379 12.842 23.5178 12.842 23.4856 12.1959V8.66222C23.4856 8.40783 23.2818 8.20257 23.0289 8.20117H22.1068Z"
                          fill="#265D91" />
                        <path
                          d="M22.8521 7.45507C23.2666 7.45507 23.6026 7.12507 23.6026 6.71801C23.6026 6.31095 23.2666 5.98096 22.8521 5.98096C22.4376 5.98096 22.1016 6.31095 22.1016 6.71801C22.1016 7.12507 22.4376 7.45507 22.8521 7.45507Z"
                          fill="#265D91" />
                      </svg>
                      INFORMATIONS
                    </button>
                  </h2>
                  <div id="kt_accordion_1_body_1" class="accordion-collapse collapse show"
                    aria-labelledby="kt_accordion_1_header_1" data-bs-parent="#kt_accordion_1">
                    <div class="accordion-body">
                      <div class="row inputs">
                        <div class="col-lg-6">
                          <div class="mb-10">
                            <label for="prenom" class="required form-label">Prénom</label>
                            <input type="text" class="form-control form-control-solid" formControlName="first_name"
                              id="prenom" placeholder="Prénom" />
                            <!-- <app-feild-error class="error-message"
                              [control]="candidateForm.get('last_name')!"></app-feild-error> -->
                              <div *ngIf="candidateForm.get('first_name')?.hasError('required') && candidateForm.get('first_name')?.touched"
                              class="text-danger">
                              Le champ "Prénom" est obligatoire.
                            </div>
                            <div class="error-message" *ngIf="
                                candidateForm
                                  .get('first_name')
                                  ?.hasError('pattern')">
                              Le champ "Prénom" est trop court.
                            </div>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="mb-10">
                            <label for="Nom" class="required form-label">Nom</label>
                            <input type="text" class="form-control form-control-solid" id="Nom"
                              formControlName="last_name" placeholder="Nom" />
                              <div *ngIf="candidateForm.get('last_name')?.hasError('required') && candidateForm.get('last_name')?.touched"
            class="text-danger">
            Le champ "Nom" est obligatoire.
          </div>
                            <div class="error-message" *ngIf="
                                candidateForm
                                  .get('last_name')
                                  ?.hasError('pattern')
                              ">
                              Le champ "Nom" est trop court.
                            </div>
                          </div>

                          
                        </div>
                  
                      </div>
                      <div class="row inputs">
                        <div class="col-lg-6">
                          <div class="mb-10">
                            <label for="email" class="form-label">Email Personnel</label>
                            <input type="email" class="form-control form-control-solid" id="email" placeholder="Email"
                              formControlName="email" />
                          </div>
                        </div>
                        <div class="col-lg-6">

                          <div class="mb-10">
                            <label for="email" class="form-label">
                              Email Professionnel ESN
                            </label>
                            <input type="email" class="form-control form-control-solid" id="email"
                              formControlName="emailProESN" [value]="
                                candidateForm.get('emailProESN')?.value || ''
                              " placeholder="Email ESN" />
                            <app-feild-error [controlName]="'email'" [control]="candidateForm.get('emailProESN')">
                            </app-feild-error>
                          </div>
                        </div>
                      </div>
                      <div class="row inputs">
                        <div class="col-lg-6">
                          <div class="mb-10">
                            <label for="email" class="form-label">
                              Email Professionnel Client Final
                            </label>
                            <input type="email" class="form-control form-control-solid" id="email"
                              formControlName="emailProClient" [value]="
                                candidateForm.get('emailProClient')?.value || ''
                              " placeholder="Email client final" />
                            <app-feild-error [controlName]="'email'" [control]="candidateForm.get('emailProClient')">
                            </app-feild-error>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="mb-10">
                            <label for="Tel" class="form-label">Tel</label>
                            <form [formGroup]="phoneForm">
                              <div class="wrapper">
                                <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="preferredCountries"
                                  [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [searchCountryFlag]="true"
                                  [searchCountryField]="[
                                    SearchCountryField.Iso2,
                                    SearchCountryField.Name
                                  ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.France"
                                  [phoneValidation]="true" [separateDialCode]="separateDialCode"
                                  [numberFormat]="PhoneNumberFormat.National" name="phone" formControlName="phone">
                                </ngx-intl-tel-input>
                              </div>
                              <!-- <app-feild-error class="error-message"
                                [control]="phoneForm.get('phone')!"></app-feild-error> -->

                              <div *ngIf="
                                  phoneForm.controls['phone'].invalid &&
                                  phoneForm.controls['phone'].touched
                                ">
                                <div *ngIf="phoneForm.get('phone')?.invalid && phoneForm.get('phone')?.touched">
                                  <span class="text-danger"
                                    *ngIf="!phoneForm.get('phone')?.errors?.hasOwnProperty('required')">Numéro de
                                    téléphone invalide</span>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div class="row inputs">
                        <div class="col-lg-6">
                          <div class="mb-10">
                            <label for="Pays" class="form-label">Pays de résidence actuel</label>
                            <ng-select [items]="paysList" id="pays_destinataire" bindLabel="name" bindValue="name"
                            [notFoundText]="'Aucun élément trouvé'"
                              [placeholder]="'Pays de résidence'" autoComplete formControlName="current_country">
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-lg-6">
                          <div class="mb-10">
                            <label for="Pays" class="form-label">Pays destinataire</label>
                            <ng-select (change)="onCountryChange('add')" [items]="paysList" [multiple]="true"
                            [notFoundText]="'Aucun élément trouvé'"
                              id="pays_destinataire" bindLabel="name" bindValue="name" [placeholder]="'Pays'"
                              autoComplete formControlName="destination_country"
                              [notFoundText]="'Aucun élément trouvé'" autoComplete>
                              <ng-template ng-optgroup-tmp let-item="item">
                                {{ item.name || "Unnamed group" }}
                              </ng-template>
                            </ng-select>
                            <app-feild-error [control]="
                                candidateForm.get('destination_country')
                              ">
                            </app-feild-error>
                          </div>
                        </div>
                      </div>
                      <div class="row inputs">
                        <div class="col-lg-6">

                          <div class="mb-10">
                            <label for="destinaire" class="form-label">Mobilité</label>
                            <ng-select #state [items]="stateList" [multiple]="true"
                              (change)="onMobilityChange('add')" id="mobilite" bindLabel="name"
                              formControlName="mobility" 
                              [notFoundText]="'Aucun élément trouvé'" bindValue="name" [placeholder]="'Mobilité'" autoComplete>
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-lg-6">

                          <div class="societe mb-10">
                            <div class="label">
                              <label for="destinaire" class="form-label">Société</label>
                            </div>
                            <div class="group">
                              <div class="group-input w-100 mr-2 " [ngClass]="!showSelect ? 'hidden-select': ''">
                                <ng-select
                                [items]="companyOptions"
                                bindLabel="name"
                                bindValue="id"
                                placeholder="Sélectionner Société"
                                [multiple]="true"
                                formControlName="selectedCompanyIds"
                                [notFoundText]="'Aucun société trouvé'"
                                (change)="onCompanyChange($event)">
                               <ng-template ng-option-tmp let-item="item" let-index="index">
                                  <div>
                                    {{ item.name }}
                                  </div>
                                </ng-template>
                              </ng-select>
                              
                              </div>
                              <div class="action">
                                <button
                                  class="dissocier"
                                  [disabled]="!candidateForm.get('selectedCompanyIds')"
                                  (click)="showDisassociateConsultantConfirmation()">
                                  Dissocier
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mb-5">
                          <div class="d-flex justify-content-between">
                            <label for="cv" class="form-label">
                              CV 
                               <span class="downloadCv" (click)="downloadFile()" *ngIf="(selectedCandidate?.cv && selectedCandidate?.cv !== 'null')  && !existCv"><i class="fa-solid fa-link" style="color:#265D91;"></i> {{selectedCandidate?.cv}} </span>
                            </label>
                            <!-- <div *ngIf="
                                selectedCandidate?.cv &&
                                selectedCandidate?.cv != 'null'
                                  ? selectedCandidate?.cv
                                  : ''
                              " (click)="resetCV()" style="color: red; cursor: pointer">X
                            </div> -->
                            <div *ngIf="
                            selectedCandidate?.cv &&
                            selectedCandidate?.cv != 'null'
                              ? selectedCandidate?.cv
                              : ''
                              " (click)="resetCV()" style="color: red; cursor: pointer; margin-bottom: 10px; margin-top: -2px;">
                              <img src="assets/media/icons/icon-delete.png" alt="" width="30px" class="cursor-pointer">
                        </div>
                          </div> 
                          <div *ngIf="existCv || selectedCandidate?.cv == null || selectedCandidate?.cv == 'null'">
                          <label for="fileInput" class="custom-file-input-label" style="display: none">
                            <a>Choisir un fichier </a>
                          </label>
                          <input formControlName="cv" id="fileInput" #inputFile type="file" name="cv" id="cv" (change)="
                              uploadCV($event); setValidatorRequirements()
                            " class="form-control mb-3" />
                          </div>
                          <span style="color: red" *ngIf="fileError"><small>{{ fileError }} </small></span>
                          <span style="color: red" *ngIf="fileExtention"><small>{{ fileExtention }} </small></span>
                          <div *ngIf="candidateForm.get('cv')?.hasError('required') && candidateForm.get('cv')?.touched"
                              class="text-danger">
                              Le champ "CV" est obligatoire.
                            </div>
                        </div>
                        <!--
                                                    <div class="mb-10">
                                                    <label for="exampleFormControlInput1" class=" form-label">CV
                                                        {{selectedCandidate?.cv&&selectedCandidate?.cv!='null'?selectedCandidate?.cv:''}}<a
                                                            class="cv" download="downloaded_cv.pdf">
                                                        </a></label>
                                                    <input id="cv" type="file"
                                                        (change)="uploadCV($event);setValidatorRequirements()"
                                                        class="form-control " accept=".pdf" />
                                                    <app-feild-error [controlName]="'cv'"
                                                        [control]="candidateForm.get('cv')">
                                                    </app-feild-error>
                                                    <span style="color:red" *ngIf="fileError"><small>{{fileError}}
                                                        </small></span>
                                                    <span style="color:red"
                                                        *ngIf="fileExtention"><small>{{fileExtention}} </small></span>
                                                </div>
                                                -->

                        <div class="mb-10">
                          <label for="exampleFormControlInput1" class="form-label">Linkedin</label>
                          <!-- <input type="text" class="form-control"
                                                        (change)="setValidatorRequirements()"
                                                        placeholder="Entrer votre profil Linkedin.." id="linkedin_link"
                                                        formControlName="linkedin_link" /> -->
                     
                            <!-- <input type="text" name="linkedin" class="form-control linkedin1 input-placeholder"
                              placeholder="https://www.linkedin.com/in/" id="linkedin" disabled/> -->
                              <input
                              type="text"
                              name="linkedin"
                              class="form-control form-control-solid"
                              id="linkedin"
                              placeholder="https://www.linkedin.com/in/"
                              (input)="setValidatorRequirements()"
                              formControlName="linkedin_link"
                            />
                            <app-feild-error
                              [control]="candidateForm.get('linkedin_link')"
                            ></app-feild-error>
  
                          <!-- <div *ngIf="candidateForm.get('linkedin_link')?.hasError('required') && candidateForm.get('linkedin_link')?.touched"
                              class="text-danger">
                              Le champ "linkedin" est obligatoire.
                            </div> -->
                          <div class="mt-5">
                            <span class="error mt-5">
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_379_198)">
                                  <path
                                    d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                                    fill="#2b5d8f" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_379_198">
                                    <rect width="16" height="16" fill="white" />
                                  </clipPath>
                                </defs>
                              </svg>
                              Il est toujours plus intéressant d'importer le CV
                              que de saisir le profil Linkedin.</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="kt_accordion_1_header_2">
                    <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#kt_accordion_1_body_2" aria-expanded="false"
                      aria-controls="kt_accordion_1_body_2">
                      <svg width="22" height="28" viewBox="0 0 22 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M15.4465 27.1572L15.449 27.1572C15.5141 27.1564 15.5784 27.1429 15.6383 27.1173L15.6385 27.1177L15.6494 27.1122C15.6729 27.1005 15.6954 27.0869 15.7167 27.0716C15.7381 27.0591 15.7586 27.045 15.7779 27.0294L15.7838 27.0247L15.7892 27.0195L21.5834 21.5834L21.5845 21.5823C21.6337 21.5354 21.6728 21.479 21.6994 21.4164L21.5153 21.3382C21.5312 21.3008 21.5393 21.2605 21.539 21.2198H21.739V21.2192V4.28195C21.739 3.35848 21.3722 2.47283 20.7192 1.81984C20.0662 1.16685 19.1805 0.8 18.2571 0.8H4.28195C3.35848 0.8 2.47283 1.16685 1.81984 1.81984C1.16685 2.47283 0.8 3.35848 0.8 4.28195V23.6753C0.8 24.5987 1.16685 25.4844 1.81984 26.1374C2.47283 26.7904 3.35848 27.1572 4.28195 27.1572L15.4465 27.1572ZM19.9811 21.7122L15.9449 25.5071V22.4073C15.9449 22.2229 16.0181 22.0461 16.1485 21.9158C16.2788 21.7854 16.4556 21.7122 16.64 21.7122H19.9811ZM20.7423 4.28195V20.7155H16.64C16.1913 20.7155 15.761 20.8937 15.4437 21.211C15.1264 21.5282 14.9482 21.9586 14.9482 22.4073V26.1605H4.28195C3.62282 26.1605 2.9907 25.8987 2.52462 25.4326C2.05855 24.9665 1.79672 24.3344 1.79672 23.6753V4.28195C1.79672 3.62282 2.05855 2.9907 2.52462 2.52462C2.9907 2.05855 3.62282 1.79672 4.28195 1.79672H18.2571C18.9162 1.79672 19.5483 2.05855 20.0144 2.52462C20.4805 2.9907 20.7423 3.62282 20.7423 4.28195Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.4" />
                        <path
                          d="M5.74995 8.90668H6.04831C6.52351 8.90668 6.97924 8.71791 7.31526 8.38189C7.65128 8.04588 7.84005 7.59014 7.84005 7.11494C7.84005 6.63974 7.65128 6.184 7.31526 5.84798C6.97924 5.51197 6.52351 5.32319 6.04831 5.32319H5.74995C5.27475 5.32319 4.81901 5.51197 4.48299 5.84798C4.14698 6.184 3.9582 6.63974 3.9582 7.11494C3.9582 7.59014 4.14698 8.04588 4.48299 8.38189C4.81901 8.71791 5.27475 8.90668 5.74995 8.90668ZM5.74995 6.31991H6.04831C6.25916 6.31991 6.46138 6.40367 6.61048 6.55277C6.75957 6.70187 6.84333 6.90408 6.84333 7.11494C6.84333 7.32579 6.75957 7.52801 6.61048 7.67711C6.46138 7.8262 6.25916 7.90996 6.04831 7.90996H5.74995C5.53909 7.90996 5.33687 7.8262 5.18778 7.67711C5.03868 7.52801 4.95492 7.32579 4.95492 7.11494C4.95492 6.90408 5.03868 6.70187 5.18778 6.55277C5.33687 6.40367 5.53909 6.31991 5.74995 6.31991Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.4" />
                        <path
                          d="M16.7894 5.32612H11.4189C10.9437 5.32612 10.488 5.5149 10.1519 5.85091C9.81592 6.18693 9.62715 6.64267 9.62715 7.11787C9.62715 7.59307 9.81592 8.04881 10.1519 8.38482C10.488 8.72084 10.9437 8.90961 11.4189 8.90961H16.7894C17.2646 8.90961 17.7203 8.72084 18.0563 8.38482C18.3923 8.0488 18.5811 7.59307 18.5811 7.11787C18.5811 6.64267 18.3923 6.18693 18.0563 5.85091C17.7203 5.5149 17.2646 5.32612 16.7894 5.32612ZM16.7894 7.91289H11.4189C11.208 7.91289 11.0058 7.82913 10.8567 7.68004C10.7076 7.53094 10.6239 7.32872 10.6239 7.11787C10.6239 6.90701 10.7076 6.7048 10.8567 6.5557C11.0058 6.4066 11.208 6.32284 11.4189 6.32284H16.7894C17.0002 6.32284 17.2024 6.4066 17.3515 6.5557C17.5006 6.7048 17.5844 6.90701 17.5844 7.11787C17.5844 7.32872 17.5006 7.53094 17.3515 7.68004C17.2024 7.82913 17.0002 7.91289 16.7894 7.91289Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.4" />
                        <path
                          d="M5.74995 15.4704H6.04831C6.52351 15.4704 6.97924 15.2816 7.31526 14.9456C7.65128 14.6096 7.84005 14.1539 7.84005 13.6787C7.84005 13.2035 7.65128 12.7477 7.31526 12.4117C6.97924 12.0757 6.52351 11.8869 6.04831 11.8869H5.74995C5.27475 11.8869 4.81901 12.0757 4.48299 12.4117C4.14698 12.7477 3.9582 13.2035 3.9582 13.6787C3.9582 14.1539 4.14698 14.6096 4.48299 14.9456C4.81901 15.2816 5.27475 15.4704 5.74995 15.4704ZM5.74995 12.8836H6.04831C6.25916 12.8836 6.46138 12.9674 6.61048 13.1165C6.75957 13.2656 6.84333 13.4678 6.84333 13.6787C6.84333 13.8895 6.75957 14.0917 6.61048 14.2408C6.46138 14.3899 6.25916 14.4737 6.04831 14.4737H5.74995C5.53909 14.4737 5.33687 14.3899 5.18778 14.2408C5.03868 14.0917 4.95492 13.8895 4.95492 13.6787C4.95492 13.4678 5.03868 13.2656 5.18778 13.1165C5.33687 12.9674 5.53909 12.8836 5.74995 12.8836Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.4" />
                        <path
                          d="M16.7894 11.8901H11.4189C10.9437 11.8901 10.488 12.0789 10.1519 12.4149C9.81592 12.7509 9.62715 13.2066 9.62715 13.6818C9.62715 14.157 9.81592 14.6128 10.1519 14.9488C10.488 15.2848 10.9437 15.4736 11.4189 15.4736H16.7894C17.2646 15.4736 17.7203 15.2848 18.0563 14.9488C18.3923 14.6128 18.5811 14.157 18.5811 13.6818C18.5811 13.2066 18.3923 12.7509 18.0563 12.4149C17.7203 12.0789 17.2646 11.8901 16.7894 11.8901ZM16.7894 14.4769H11.4189C11.208 14.4769 11.0058 14.3931 10.8567 14.244C10.7076 14.0949 10.6239 13.8927 10.6239 13.6818C10.6239 13.471 10.7076 13.2688 10.8567 13.1197C11.0058 12.9706 11.208 12.8868 11.4189 12.8868H16.7894C17.0002 12.8868 17.2024 12.9706 17.3515 13.1197C17.5006 13.2688 17.5844 13.471 17.5844 13.6818C17.5844 13.8927 17.5006 14.0949 17.3515 14.244C17.2024 14.3931 17.0002 14.4769 16.7894 14.4769Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.4" />
                        <path
                          d="M4.45852 19.9459H7.34365C7.47582 19.9459 7.60258 19.8934 7.69604 19.7999C7.7895 19.7065 7.842 19.5797 7.842 19.4475C7.842 19.3154 7.7895 19.1886 7.69604 19.0951C7.60258 19.0017 7.47582 18.9492 7.34365 18.9492H4.45852C4.32634 18.9492 4.19958 19.0017 4.10612 19.0951C4.01266 19.1886 3.96016 19.3154 3.96016 19.4475C3.96016 19.5797 4.01266 19.7065 4.10612 19.7999C4.19958 19.8934 4.32634 19.9459 4.45852 19.9459Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.4" />
                        <path
                          d="M11.5177 22.2312H4.45852C4.32634 22.2312 4.19958 22.2837 4.10612 22.3771C4.01266 22.4706 3.96016 22.5973 3.96016 22.7295C3.96016 22.8617 4.01266 22.9884 4.10612 23.0819C4.19958 23.1754 4.32634 23.2279 4.45852 23.2279H11.5177C11.6499 23.2279 11.7766 23.1754 11.8701 23.0819C11.9635 22.9884 12.016 22.8617 12.016 22.7295C12.016 22.5973 11.9635 22.4706 11.8701 22.3771C11.7766 22.2837 11.6499 22.2312 11.5177 22.2312Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.4" />
                      </svg>
                      Synthèse
                    </button>
                  </h2>
                  <div id="kt_accordion_1_body_2" class="accordion-collapse collapse"
                    aria-labelledby="kt_accordion_1_header_2" data-bs-parent="#kt_accordion_1">
                    <div class="accordion-body">
                      <div class="content">
                        <div class="formations mb-10">
                          <div class="row">
                            <div class="poste tools">
                              <div class="mb-10">
                                <label for="titre" class="form-label">Titre</label>
                                <input type="text" class="form-control" placeholder="Titre" formControlName="desired_workstation" />
                                <div *ngIf="candidateForm.get('desired_workstation')?.hasError('maxlength')" class="error-message">
                                  Le titre ne peut pas dépasser 100 caractères.
                                </div>
                              </div>
                              <app-feild-error [control]="
                                  candidateForm.get('desired_workstation')
                                ">
                              </app-feild-error>
                              <!-- <div class="title mb-10">
                                <label class="mb-3" >
                                  Date début de première expérience
                                  professionnelle
                                </label>
                                <input type="date" placeholder="Date de la premiére expérience"
                                  formControlName="date_first_experience" (change)="selectDate(); calculateExperience()"
                                  class="form-control form-control-solid mb-3" />
                                <app-feild-error [control]="candidateForm.get('date_first_experience')"></app-feild-error>
                              </div> -->
                              <div class="row">
                                <div class="mb-5 col">
                                  <label for="date-first-exp" class="form-label">  Date début de première expérience professionnelle</label>
                               

                                  <input 
                                  type="date" 
                                  [max]="currentDate"
                                  [min]="minDate"
                                  placeholder="Date de la première expérience"
                                  formControlName="date_first_experience" 
                                  (change)="selectDate();calculateExperience()"
                                  class="form-control form-control-solid mb-3" [ngClass]="{'disabled-date': experience}"
                                >

                                </div>
                              
                                <div class="mb-5 col">
                                  <div class="form-check checkExperiance">
                                    <label for="date-first-exp" class="form-label">Aucune expérience</label>
                                      <input 
                                      class="form-check-input checkbox-border" 
                                      type="checkbox"
                                      (change)="changeExperience($event)" 
                                      [checked]="experience" 
                                      id="flexCheckDefault" 
                                    />
                                    </div>
                               </div>
                                <div class="desclaimer mt-4 mb-5" *ngIf="isChosenDateValid">
                                  <p class="errDate">
                                    La date sélectionnée est dans le futur, il  faut choisir une autre date
                                  </p>
                                </div>
                               </div>
                              <div class="desclaimer mt-4 mb-5" *ngIf="isexp && !experience && !isChosenDateValid">
                                <span class="nombre">Nombre des années d'expérience:
                                  {{ experienceText }}</span>
                              </div>
                              <div class="title mb-10">
                                <label for="slaire" class="mb-3">Contrats souhaité
                                </label>

                                <div class="row list-contracts">
                                  <div class="col-lg-4" *ngFor="let item of listCantrat">
                                    <div class="form-check form-check-custom form-check-solid mb-3">
                                      <input class="form-check-input" (change)="
                                          handleContractsCheckbox(
                                            $event,
                                            item.value
                                          )
                                        " type="checkbox" [id]="item.id" [checked]="
                                          item?.checked !== null &&
                                          item?.checked
                                        " [value]="item.id" />
                                      <label class="form-check-label">{{ item.label }}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="mb-10">
                                <label for="slaire" class="mb-3">Salaire brut/an souhaité
                                </label>
                                <div class="input-group mb-5">
                                  <input min="0" (keypress)="keyPress($event)" type="text" class="form-control"
                                    value="4500" id="salaire" aria-label="" aria-describedby="basic-addon2"
                                    placeholder="Salaire brut/an souhaité" formControlName="desired_salary" />
                                  <span class="input-group-text" id="basic-addon2">€</span>
                                </div>
                              </div>
                              <div class="mb-10">
                                <label for="slaire" class="mb-3">TJM</label>
                                <div class="input-group mb-5">
                                  <input type="text" min="0" placeholder="Tjm" (keypress)="keyPress($event)"
                                    class="form-control" value="500" id="tjm" aria-label="TJM"
                                    aria-describedby="basic-addon2" formControlName="tjm" />
                                  <span class="input-group-text" id="basic-addon2">€</span>
                                </div>
                              </div>
                              <div class="mb-10">
                                <label for="savoir" class="form-label">À propos
                                </label>
                                <!-- <textarea name="savoir-etre" id="savoir" class="form-control"
                                  formControlName="savoir_faire"></textarea> -->
                                   <quill-editor formControlName="savoir_faire" placeholder="À propos" [modules]="toolbarOptions"
                                    style="width: 100%; height: 200px;"></quill-editor>
                                  <div
                                  *ngIf="
                                    candidateForm
                                      .get('savoir_faire')
                                      ?.hasError('maxlength')
                                  "
                                  class="error-message"
                                >
                                À propos ne peut pas dépasser 500 caractères.
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class=" mb-15 Soft_Skills">
                            <label for="source" class="form-label">Soft Skills</label>
                            <ng-select
                            [items]="soft"
                            placeholder="Soft Skills"
                            bindLabel="name"
                            bindValue="name"
                            [multiple]="true"
                            formControlName="softSkills"
                          >
                          </ng-select>
                          </div>
                          <div class="row mb-15">
                            <div class="type label-design">
                              <div class="choix">
                                <label for="mission" class="form-label">Ouvert pour une nouvelle mission
                                </label>
                                <div class="radio d-flex">
                                  <div class="form-check">
                                    <input class="form-check-input" type="radio" id="huey" name="drone"
                                    (click)="updateOpenForMission(0)" 
                                    [checked]="CheckedMission=='0'"value="0"/>
                                    <label  for="huey">Non
                                    </label>
                                </div>
                                <div class="form-check">
                                    <input class="form-check-input" type="radio" name="drone" value="" id="dewey" value="1"
                                    [checked]="CheckedMission=='1'"
                                    (click)="updateOpenForMission(1)" />
                                    <label  for="dewey">Oui
                                    </label>
                                </div>
                              </div>
                                <!-- <div class="radio d-flex">
                                  <div class="form-check form-check-custom form-check-solid">
                                    <input class="form-check-input" type="radio" value="0" id="flexRadioDefault0"
                                      (click)="updateOpenForMission(0)" [checked]="CheckedMission == '0'" />
                                    <label class="form-check-label mission" for="flexRadioDefault0">
                                      Non
                                    </label>
                                  </div>
                                  <div class="form-check form-check-custom form-check-solid">
                                    <input class="form-check-input" type="radio" value="1"
                                      [checked]="CheckedMission == '1'" id="flexRadioDefault1"
                                      (click)="updateOpenForMission(1)" />
                                    <label class="form-check-label mission" for="flexRadioDefault1">
                                      Oui
                                    </label>
                                  </div>
                                </div> -->
                              </div>
                            </div>
                          </div>
                         
                          <div class="row label-design">
                            <label for="mission" class="form-label">Disponibilité</label>
                            <div class="choix mb-5">
                              <div class="radio d-flex">
                                 

                                  <div class="form-check" *ngFor="let option of disponibilite">
 
                                      <input class="form-check-input" type="radio" name="availability"
                                      [id]="option.id" [value]="option.value"
                                          (click)="updateAvailability(option.value)"
                                          [checked]="selectedAvailability == option.value" />
                                      <label  for="dispo">{{ option.name }}
                                      </label>
                                  </div>

                                  <!-- <div *ngFor="let option of disponibilite"
                                      class="form-check form-check-custom form-check-solid">
                                      <input class="form-check-input" type="radio"
                                          [id]="option.id" [value]="option.value"
                                          (click)="updateAvailability(option.value)"
                                          [checked]="selectedAvailability === option.value" />
                                      <label class="form-check-label" [for]="option.id">
                                          {{ option.name }}
                                      </label>
                                  </div> -->
                              </div>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="kt_accordion_1_header_3">
                    <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#kt_accordion_1_body_3" aria-expanded="false"
                      aria-controls="kt_accordion_1_body_3">
                      <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.10097 0.00083786C6.24583 0.00083786 5.53345 0.714159 5.53345 1.57104V1.75817C5.355 1.82241 5.17684 1.89502 5.00313 1.97602L4.87209 1.84475C4.26677 1.23812 3.25968 1.23812 2.65436 1.84475L1.84076 2.65945C1.23545 3.26608 1.23545 4.2749 1.84076 4.88097L1.97181 5.01224C1.89095 5.1854 1.81846 5.36304 1.75433 5.54346H1.56752C0.712104 5.54346 0 6.25678 0 7.11366V8.26799C0 9.12515 0.712104 9.83847 1.56752 9.83847H1.75433C1.81846 10.02 1.89095 10.196 1.97181 10.3694L1.84076 10.5007C1.23545 11.1073 1.23545 12.1158 1.84076 12.7222L2.65436 13.5372C3.25968 14.1438 4.26677 14.1438 4.87209 13.5372L5.00313 13.4059C5.176 13.4869 5.35361 13.5595 5.53345 13.6238V13.8109C5.53345 14.6681 6.24583 15.3814 7.10097 15.3814H8.25333C9.10902 15.3814 9.82141 14.6681 9.82141 13.8109V13.6238C9.99985 13.5595 10.178 13.4869 10.3514 13.4059L10.4825 13.5372C11.0881 14.1438 12.0952 14.1438 12.7002 13.5372L13.5141 12.7222C14.1194 12.1158 14.1194 11.1073 13.5141 10.5007L13.383 10.3694C13.4639 10.1962 13.5364 10.0189 13.6005 9.83847H13.7873C14.643 9.83847 15.3551 9.12515 15.3551 8.26799V7.11366C15.3551 6.25678 14.643 5.54346 13.7873 5.54346H13.6033C13.5392 5.36192 13.4639 5.18541 13.383 5.0114L13.5141 4.88014C14.1194 4.27406 14.1194 3.26525 13.5141 2.65862L12.7002 1.84391C12.0952 1.23728 11.0881 1.23728 10.4825 1.84391L10.3514 1.97518C10.1786 1.89418 10.0007 1.81877 9.82057 1.75454V1.5702C9.82057 0.713321 9.10819 0 8.25249 0L7.10097 0.00083786ZM7.10097 1.46574H8.25333C8.32582 1.46574 8.35928 1.49926 8.35928 1.57188V2.29246C8.35923 2.45441 8.41276 2.61181 8.51148 2.74006C8.6102 2.8683 8.74856 2.96018 8.90493 3.00131C9.33208 3.11303 9.74194 3.2834 10.1228 3.50684C10.2624 3.58865 10.4252 3.62178 10.5856 3.60106C10.7461 3.58034 10.8951 3.50694 11.0095 3.39233L11.5175 2.88317C11.5677 2.8329 11.6151 2.8329 11.6652 2.88317L12.4788 3.69816C12.529 3.74843 12.529 3.79591 12.4788 3.84618L11.9708 4.35562C11.8564 4.47016 11.7831 4.61946 11.7624 4.78017C11.7418 4.94087 11.7748 5.10391 11.8565 5.24378C12.0796 5.6253 12.2491 6.03558 12.3612 6.46346C12.4022 6.6201 12.4938 6.75873 12.6218 6.85767C12.7498 6.95661 12.9069 7.01029 13.0685 7.01032H13.7879C13.8604 7.01032 13.8938 7.04384 13.8938 7.11646V8.27079C13.8938 8.3434 13.8604 8.37692 13.7879 8.37692H13.0652C12.9032 8.37685 12.7458 8.43065 12.6176 8.52987C12.4894 8.6291 12.3978 8.76814 12.357 8.92518C12.2455 9.35278 12.0773 9.76334 11.8557 10.1451C11.7744 10.2848 11.7416 10.4475 11.7622 10.6079C11.7829 10.7682 11.856 10.9172 11.97 11.0316L12.478 11.5408C12.5282 11.5911 12.5282 11.6385 12.478 11.6888L11.6644 12.5041C11.6142 12.5543 11.5668 12.5543 11.5166 12.5041L11.0086 11.9949C10.8944 11.8806 10.7456 11.8074 10.5855 11.7867C10.4253 11.766 10.2629 11.7989 10.1234 11.8804C9.74222 12.1038 9.33236 12.2717 8.90548 12.3829C8.74876 12.4237 8.60999 12.5155 8.51094 12.6438C8.41189 12.7721 8.35815 12.9298 8.35816 13.092V13.8159C8.35816 13.8885 8.3247 13.9221 8.25221 13.9221H7.09985C7.02736 13.9221 6.9939 13.8885 6.9939 13.8159V13.092C6.99392 12.9298 6.94023 12.7722 6.84123 12.6439C6.74224 12.5155 6.60353 12.4237 6.44686 12.3829C6.01971 12.2711 5.61012 12.1027 5.22898 11.8804C5.08949 11.7989 4.92702 11.766 4.76689 11.7867C4.60676 11.8074 4.45797 11.8806 4.34372 11.9949L3.83544 12.5041C3.78525 12.5543 3.73785 12.5543 3.68766 12.5041L2.87435 11.6888C2.82416 11.6385 2.82416 11.5911 2.87435 11.5408L3.38236 11.0316C3.49638 10.9172 3.56942 10.7682 3.5901 10.6079C3.61077 10.4475 3.57793 10.2848 3.49667 10.1451C3.2764 9.76334 3.10605 9.35278 2.99508 8.92518C2.95431 8.76818 2.86269 8.62918 2.73457 8.52996C2.60646 8.43074 2.44909 8.37691 2.28715 8.37692H1.56418C1.49168 8.37692 1.45822 8.3434 1.45822 8.27079V7.11646C1.45822 7.04384 1.49168 7.01032 1.56418 7.01032H2.28715C2.44909 7.01033 2.60646 6.95651 2.73457 6.85729C2.86269 6.75806 2.95431 6.61906 2.99508 6.46207C3.1066 6.03419 3.27501 5.6239 3.49667 5.2421C3.57793 5.10241 3.61077 4.93972 3.5901 4.77938C3.56942 4.61903 3.49638 4.47004 3.38236 4.35562L2.87435 3.84646C2.82416 3.79619 2.82416 3.74871 2.87435 3.69843L3.68766 2.88373C3.73785 2.83346 3.78525 2.83346 3.83544 2.88373L4.34372 3.39261C4.45797 3.50689 4.60676 3.58009 4.76689 3.60081C4.92702 3.62152 5.08949 3.58858 5.22898 3.50712C5.61012 3.28368 6.01971 3.11582 6.44686 3.00466C6.60353 2.96378 6.74224 2.87198 6.84123 2.74365C6.94023 2.61532 6.99392 2.45771 6.9939 2.29553V1.57132C6.9939 1.4987 7.02847 1.46574 7.10097 1.46574ZM17.4672 4.02968C17.4043 4.02144 17.3405 4.02144 17.2776 4.02968C17.1512 4.05243 17.0333 4.1081 16.9352 4.19111C16.8372 4.27411 16.7626 4.38152 16.7191 4.50253C16.6866 4.59307 16.6722 4.68913 16.6768 4.78523C16.6814 4.88134 16.7048 4.9756 16.7457 5.06264C16.7866 5.14968 16.8443 5.22779 16.9154 5.29251C16.9864 5.35723 17.0695 5.4073 17.1599 5.43984C20.0602 6.48469 22.1374 9.25698 22.1377 12.5264C22.1366 12.6074 22.1374 12.6018 22.1371 12.694C22.1369 12.789 22.1366 12.9146 22.1363 13.0398C22.1357 13.2883 22.1349 13.5361 22.1349 13.5361C22.1349 13.6299 22.1529 13.7228 22.1879 13.8098L23.6952 17.5912H22.3738C22.2778 17.5911 22.1827 17.6101 22.0939 17.6469C22.0051 17.6837 21.9245 17.7376 21.8566 17.8057C21.7886 17.8737 21.7347 17.9545 21.6979 18.0434C21.6612 18.1323 21.6422 18.2275 21.6422 18.3238V21.0497H18.0304C17.8644 21.0497 17.7034 21.1064 17.5738 21.2102C17.4442 21.314 17.3537 21.4589 17.3172 21.6211L16.6918 24.3982H10.2979L11.1221 19.7605C11.1483 19.6134 11.129 19.4619 11.0668 19.3262C11.0046 19.1905 10.9025 19.077 10.7741 19.001C10.0475 18.5712 9.41043 18.0299 8.879 17.4063C8.75298 17.2586 8.57356 17.1671 8.38021 17.1519C8.18685 17.1367 7.99538 17.1991 7.84792 17.3253C7.70057 17.4515 7.60927 17.6312 7.59411 17.8248C7.57895 18.0184 7.64116 18.2101 7.76707 18.3578C8.29348 18.9759 8.90827 19.5244 9.59668 19.9872L8.70557 25.0028C8.68685 25.1082 8.6914 25.2164 8.71892 25.3199C8.74644 25.4233 8.79625 25.5195 8.86485 25.6015C8.93345 25.6836 9.01917 25.7496 9.11598 25.795C9.21279 25.8403 9.31834 25.8638 9.4252 25.8639H17.2773C17.4433 25.8639 17.6044 25.8073 17.7341 25.7035C17.8637 25.5996 17.9543 25.4547 17.9908 25.2925L18.6159 22.5154H22.3744C22.5684 22.5154 22.7544 22.4382 22.8915 22.3008C23.0287 22.1634 23.1057 21.9771 23.1057 21.7828V19.0569H24.7753C24.8948 19.0569 25.0125 19.0276 25.1181 18.9716C25.2237 18.9155 25.3139 18.8344 25.381 18.7353C25.448 18.6362 25.4898 18.5221 25.5027 18.4031C25.5155 18.2841 25.4991 18.1637 25.4548 18.0526L23.5993 13.3989C23.5995 13.3124 23.5998 13.223 23.6004 13.0445C23.6006 12.9188 23.6009 12.7959 23.6012 12.699C23.6015 12.6041 23.6034 12.4532 23.6018 12.5454C23.602 8.65286 21.1247 5.32729 17.6562 4.07772C17.5961 4.05561 17.5332 4.04153 17.4694 4.03582L17.4672 4.02968ZM7.67729 4.12185C5.71663 4.12185 4.11175 5.72947 4.11175 7.69348C4.11175 9.65749 5.71663 11.2654 7.67729 11.2654C9.63822 11.2654 11.2431 9.65749 11.2431 7.69348C11.2431 5.72947 9.63822 4.12185 7.67729 4.12185ZM7.67729 5.58675C8.84749 5.58675 9.78042 6.52128 9.78042 7.69348C9.78042 8.86569 8.84749 9.80021 7.67729 9.80021C6.50736 9.80021 5.57443 8.86569 5.57443 7.69348C5.57443 6.52128 6.50736 5.58675 7.67729 5.58675Z"
                          fill="#265D91" />
                      </svg>
                      COMPÉTENCES
                    </button>
                  </h2>
                  <div id="kt_accordion_1_body_3" class="accordion-collapse collapse"
                    aria-labelledby="kt_accordion_1_header_3" data-bs-parent="#kt_accordion_1">
                    <div class="accordion-body">
                      <div class="content compte">
                        <div class="row mb-15">
                          <div class="mb-10">
                            <div class="input_compt">
                              <ng-select
                              [items]="skillsList"
                              bindLabel="name_FR"
                              bindValue="id"
                              formControlName="sub_category_id"
                              [multiple]="true"
                              id="competences"
                              placeholder="Compétences"
                              (change)="getItemSkill($event)"
                              [notFoundText]="'Aucun élément trouvé'"
                              autoComplete
                              (remove)="onRemoveSkill($event)"
                              (clear)="onItemClear($event)"
                            >
                            </ng-select>
                   
                            </div>
                          </div>
                        
                          <div class="responsive" *ngFor="let skill of skillsCandidat; let i = index">
                            <table class="table">
                              <thead>
                                <th style="
                                    text-align: left;
                                    font-size: 14px !important;
                                  ">
                                  <span> {{ skill.name_FR }} </span>
                                </th>
                                <th style="
                                    text-align: right;
                                    padding-right: 25px;
                                    font-size: 14px !important;
                                  ">
                                  <span class="required">Évaluations</span>
                                </th>
                              </thead>
                              <tbody>
                                <tr *ngFor="
                                    let subSkill of skill.sub_category;
                                    let j = index
                                  ">
                                  <td>
                                    <span class="skill-name" (click)="
                                        deleteOnSkillCandidat(
                                            subSkill.id
                                        )
                                      "><i class="fa-solid fa-xmark" style="
                                          font-size: 14px;
                                          color: red;
                                          margin-right: 5px;
                                          cursor: pointer;
                                        "></i>
                                      {{ subSkill.name_FR }}</span>
                                  </td>
                                  <td>
                                    <div class="stars">
                                      <i class="fa fa-star gold" (click)="
                                          setRating(i,j,'1')"></i>
                                      <i class="fa fa-star" (click)="
                                          setRating(i, j,'2')
                                        " [class.gold]="subSkill?.skills[0].stars>='2'"></i>
                                      <i class="fa fa-star" (click)="
                                          setRating(i,j,'3')
                                        " [class.gold]="subSkill?.skills[0].stars>='3'"></i>
                                      <i class="fa fa-star" (click)="
                                          setRating(i,j,'4')
                                        " [class.gold]="subSkill?.skills[0].stars>='4'"></i>
                                      <i class="fa fa-star" (click)="
                                          setRating(i,j,'5')
                                        " [class.gold]="subSkill?.skills[0].stars>='5'"></i>
                                     
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div class="autres mt-5">
                            <div class="input-reset">
                              <label for="autres">Autres Compétences</label>
                              <mat-form-field class="example-chip-list">
                                <mat-chip-grid #chipGrid aria-label="Enter skill">
                                  <mat-chip-row *ngFor="let skill of addSkills" (removed)="remove(skill)"
                                    [editable]="true" (edited)="edit(skill, $event)" [aria-description]="
                                      'press enter to edit ' + skill.name
                                    ">
                                    {{ skill.name }}
                                    <button matChipRemove [attr.aria-label]="'remove ' + skill.name">
                                      <mat-icon>x</mat-icon>
                                    </button>
                                  </mat-chip-row>
                                  <input placeholder="Autres compétences ( à séparer par , )" (blur)="isFormatCompetenceAdmin=false"
                                    [matChipInputFor]="chipGrid" [matChipInputSeparatorKeyCodes]="
                                      separatorKeysCodes
                                    " [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event)" />
                                 
                                </mat-chip-grid>

                            

                              </mat-form-field><br/>
                            </div><br/>
                            <p *ngIf="isFormatCompetenceAdmin"> Suivez le format attendu pour l'ajout de compétences </p>

                            <div class="reset-compt">
                              <button  [disabled]="!skillsCandidat?.length" (click)="clearAllSkills()" style="cursor: pointer"><svg width="19" height="20"
                                  viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path
                                    d="M9.1556 1.65343C7.06488 1.6595 5.03956 2.3875 3.41804 3.71578L3.64754 1.10897C3.66602 0.890184 3.59738 0.67297 3.45674 0.505114C3.31609 0.337258 3.11494 0.232509 2.89756 0.213912C2.78992 0.204704 2.68154 0.216924 2.57859 0.249873C2.47564 0.282823 2.38015 0.335858 2.29757 0.405949C2.13079 0.547505 2.02672 0.749944 2.00824 0.968732L1.57382 5.91837C1.558 6.13595 1.62846 6.35099 1.76978 6.51641C1.91111 6.68184 2.11178 6.78418 2.3279 6.80105L7.24581 7.23827H7.31958C7.53696 7.24812 7.74933 7.17065 7.90996 7.0229C8.0706 6.87516 8.16633 6.66924 8.17612 6.45046C8.1859 6.23167 8.10892 6.01793 7.96213 5.85626C7.81533 5.69459 7.61073 5.59824 7.39335 5.58839L4.01638 5.29142C5.27221 4.11385 6.89277 3.40767 8.60529 3.29174C10.3178 3.17581 12.0178 3.6572 13.419 4.65489C14.8201 5.65258 15.8371 7.10565 16.2985 8.76951C16.76 10.4334 16.6378 12.2065 15.9526 13.7903C15.2673 15.3741 14.0609 16.672 12.5363 17.4655C11.0116 18.259 9.26196 18.4996 7.58173 18.1469C5.90149 17.7941 4.39329 16.8696 3.31099 15.5288C2.22869 14.1881 1.63837 12.513 1.63939 10.7855C1.63939 10.5667 1.55304 10.3569 1.39932 10.2022C1.24561 10.0475 1.03713 9.96057 0.819743 9.96057C0.602358 9.96057 0.393877 10.0475 0.240162 10.2022C0.0864478 10.3569 9.17625e-05 10.5667 9.17625e-05 10.7855C-0.00799549 12.5998 0.518646 14.3758 1.51342 15.8888C2.5082 17.4019 3.92642 18.584 5.58876 19.2859C7.2511 19.9877 9.08289 20.1776 10.8525 19.8317C12.6221 19.4857 14.25 18.6194 15.5304 17.3423C16.8108 16.0652 17.6862 14.4346 18.0458 12.6568C18.4055 10.8789 18.2332 9.03368 17.5509 7.35437C16.8685 5.67506 15.7067 4.23711 14.2124 3.22235C12.718 2.2076 10.9583 1.66161 9.1556 1.65343Z"
                                    fill="white" />
                                </svg>
                                Réinitialiser
                              </button>
                            </div>
                          </div>
                        </div>

                       
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="kt_accordion_1_header_4">
                    <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#kt_accordion_1_body_4" aria-expanded="false"
                      aria-controls="kt_accordion_1_body_4">
                      <svg width="32" height="22" viewBox="0 0 32 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M30.8287 5.85159L15.9759 0.0589779C15.7856 -0.0196593 15.572 -0.0196593 15.3817 0.0589779L0.52888 5.85159C0.379927 5.90958 0.250888 6.00935 0.157267 6.13891C0.0636456 6.26847 0.0094255 6.4223 0.00112116 6.58193C-0.00718318 6.74156 0.0307815 6.90019 0.110454 7.03876C0.190126 7.17733 0.308116 7.28995 0.450247 7.36309L5.78854 10.0366V16.965C5.82085 17.5067 5.9901 18.0313 6.28043 18.4897C6.57077 18.9481 6.97269 19.3254 7.44856 19.5861C9.35322 20.8705 12.5946 21.5345 15.7225 21.5345C18.8503 21.5345 22.0917 20.8705 23.9964 19.5861C24.4723 19.3254 24.8742 18.9481 25.1645 18.4897C25.4549 18.0313 25.6241 17.5067 25.6564 16.965V10.0366L27.3077 9.16291V17.3407C27.3652 17.5155 27.4763 17.6677 27.6254 17.7756C27.7744 17.8835 27.9537 17.9416 28.1377 17.9416C28.3217 17.9416 28.501 17.8835 28.6501 17.7756C28.7991 17.6677 28.9103 17.5155 28.9677 17.3407V8.37658L30.9947 7.36309C31.1368 7.28995 31.2548 7.17733 31.3345 7.03876C31.4142 6.90019 31.4521 6.74156 31.4438 6.58193C31.4355 6.4223 31.3813 6.26847 31.2877 6.13891C31.1941 6.00935 31.065 5.90958 30.9161 5.85159H30.8287ZM2.77428 6.72529L15.6351 1.71027L28.4959 6.71655L16.9981 12.5092L15.6351 13.147L14.2721 12.5092L2.77428 6.72529ZM23.909 14.3789V17C23.909 18.2144 20.7637 19.9006 15.6351 19.9006C10.5065 19.9006 7.36119 18.1795 7.36119 16.965V10.8491L11.3453 12.8499L13.8877 14.1342L15.2245 14.807C15.3398 14.8697 15.4689 14.9025 15.6002 14.9025C15.7314 14.9025 15.8606 14.8697 15.9759 14.807L17.3825 14.1342L19.9599 12.8586L23.944 10.8579L23.909 14.3789Z"
                          fill="#265D91" />
                      </svg>

                      FORMATIONS
                    </button>
                  </h2>
                  <div id="kt_accordion_1_body_4" class="accordion-collapse collapse"
                    aria-labelledby="kt_accordion_1_header_4" data-bs-parent="#kt_accordion_1">
                    <div class="accordion-body">
                      <div>
                        <div class="formations mb-10">
                          <div class="responsive-table" formArrayName="diplome">
                            <table class="table align-middle fs-6 gy-5" id="kt_customers_table"
                              style="box-shadow: none !important">
                              <thead class="text-uppercase gs-0 fw-bold">
                                <th class="min-w-125px" style="white-space: nowrap;">Année</th>
                                <th class="min-w-125px  required" style="white-space: nowrap;">Diplome</th>
                                <th class="min-w-125px" style="white-space: nowrap;">Univertisé / Ecole</th>
                                <th class="min-w-125px" style="white-space: nowrap;">Mention</th>
                                <th class="min-w-90px"style="white-space: nowrap;">Actions</th>
                              </thead>

                              <tbody>
                                <ng-container
                                  *ngFor="
                                    let diploma of diplomaControls;
                                    let i = index
                                  "
                                >
                                  <tr [formGroupName]="i">
                                    <td>
                                      <div class="height-certif">
                                       
                                        <p-calendar [style]="{'border': 'none','margin-top': '-6px'}"  view="year" dateFormat="yy" placeholder="Année" inputId="yearpicker" formControlName="date"
                                        (ngModelChange)="selectDate1forma(i)"  (input)="onInput($event)" class="form-control" ></p-calendar>
                                    <!--
                                    <div *ngIf="submittedDeplomes[i]">
                                          <div
                                          *ngIf="
                                            candidateForm
                                              .get('diplome.' + i + '.date')
                                              ?.hasError('required') || 
                                            candidateForm.get(
                                              'diplome.' + i + '.date'
                                            )?.touched
                                          "
                                          class="text-danger"
                                        >
                                        <small *ngIf="candidateForm
                                        .get('diplome.' + i + '.date')
                                        ?.hasError('required')">

                                          Le champ  "Année" est
                                          obligatoire. 

                                        </small>  
                                        
                                        </div>
                                    </div>
                                    -->
                                      </div>
                                    </td>
                                    <td>
                                      <div class="height-certif">
                                        <input
                                          type="text"
                                          formControlName="name"
                                          class="form-control"
                                          placeholder="Diplome"
                                          (click)="checkInputDiplome(i)"
                                        />


                                       
                                      <div *ngIf="submittedDeplomes[i]">

                                        <div
                                          *ngIf="
                                            candidateForm.get(
                                              'diplome.' + i + '.name'
                                            )?.invalid ||
                                            candidateForm.get(
                                              'diplome.' + i + '.name'
                                            )?.touched
                                          "
                                        >
                                          <div
                                            *ngIf="
                                              candidateForm
                                                .get('diplome.' + i + '.name')
                                                ?.hasError('required')
                                             
                                            "
                                            class="text-danger"
                                          >

                                          <small *ngIf="candidateForm
                                          .get('diplome.' + i + '.name')
                                          ?.hasError('required')">
                                            Le champ  "Diplome" est
                                            obligatoire.
                                          </small>


                                          </div>
                                        </div>

                                      </div>
                                       
                                      </div>
                                    </td>
                                    <td>
                                      <div class="height-certif">
                                        <input
                                          type="text"
                                          formControlName="ecole"
                                          class="form-control"
                                          placeholder="Ecole"
                                        />
                                      </div>
                                    </td>
                                    <td>
                                      <div class="height-certif">
                                        <ng-select
                                          [items]="mention"
                                          id="Mention"
                                          bindLabel="name"
                                          bindValue="name"
                                          placeholder="Mention"
                                          formControlName="mention"
                                          [notFoundText]="
                                            'Aucun élément trouvé'
                                          "
                                        >
                                        </ng-select>
                                      </div>
                                    </td>
                                    <td>
                                      <div class="actions">
                                        <a
                                          class="delete"
                                          (click)="removeDiploma(i)"
                                        >
                                          <svg
                                            width="20"
                                            height="23"
                                            viewBox="0 0 20 23"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M18.3004 5.0961H19.1502C19.3756 5.0961 19.5917 5.00657 19.7511 4.8472C19.9105 4.68784 20 4.47169 20 4.24631C20 4.02093 19.9105 3.80478 19.7511 3.64541C19.5917 3.48604 19.3756 3.39651 19.1502 3.39651H14.9012V2.54671C14.8992 1.87119 14.63 1.22391 14.1523 0.746244C13.6746 0.268576 13.0273 -0.000668049 12.3518 -0.00268555H7.25303C6.57751 -0.000668049 5.93023 0.268576 5.45256 0.746244C4.97489 1.22391 4.70565 1.87119 4.70363 2.54671V3.39651H0.849798C0.624418 3.39651 0.408268 3.48604 0.2489 3.64541C0.0895318 3.80478 0 4.02093 0 4.24631C0 4.47169 0.0895318 4.68784 0.2489 4.8472C0.408268 5.00657 0.624418 5.0961 0.849798 5.0961H1.30444V17.8431C1.30444 18.97 1.7521 20.0507 2.54894 20.8476C3.34578 21.6444 4.42653 22.0921 5.55343 22.0921H14.0514C15.1783 22.0921 16.2591 21.6444 17.0559 20.8476C17.8527 20.0507 18.3004 18.97 18.3004 17.8431V5.0961ZM8.10283 16.1435C8.10283 16.3689 8.01329 16.585 7.85393 16.7444C7.69456 16.9037 7.47841 16.9933 7.25303 16.9933C7.02765 16.9933 6.8115 16.9037 6.65213 16.7444C6.49276 16.585 6.40323 16.3689 6.40323 16.1435V9.34509C6.40323 9.11971 6.49276 8.90356 6.65213 8.7442C6.8115 8.58483 7.02765 8.4953 7.25303 8.4953C7.47841 8.4953 7.69456 8.58483 7.85393 8.7442C8.01329 8.90356 8.10283 9.11971 8.10283 9.34509V16.1435ZM13.2016 16.1435C13.2016 16.3689 13.1121 16.585 12.9527 16.7444C12.7933 16.9037 12.5772 16.9933 12.3518 16.9933C12.1264 16.9933 11.9103 16.9037 11.7509 16.7444C11.5915 16.585 11.502 16.3689 11.502 16.1435V9.34509C11.502 9.11971 11.5915 8.90356 11.7509 8.7442C11.9103 8.58483 12.1264 8.4953 12.3518 8.4953C12.5772 8.4953 12.7933 8.58483 12.9527 8.7442C13.1121 8.90356 13.2016 9.11971 13.2016 9.34509V16.1435ZM13.2016 3.39651H6.40323V2.54671C6.40323 2.32133 6.49276 2.10518 6.65213 1.94581C6.8115 1.78644 7.02765 1.69691 7.25303 1.69691H12.3518C12.5772 1.69691 12.7933 1.78644 12.9527 1.94581C13.1121 2.10518 13.2016 2.32133 13.2016 2.54671V3.39651Z"
                                              fill="#EE6352"
                                            />
                                          </svg>
                                        </a>
                                      </div>
                                    </td>
                                  </tr>
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div class="add-row">
                          <button class="add-diplome" (click)="addDiplome()">
                            + Ajouter
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                <div class="accordion-item">
                  <h2 class="accordion-header" id="kt_accordion_1_header_5">
                    <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#kt_accordion_1_body_5" aria-expanded="false"
                      aria-controls="kt_accordion_1_body_5">
                      <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M5.6483 6.49023H19.2758C19.7539 6.49023 20.1125 6.1032 20.1125 5.65661C20.1125 5.18026 19.724 4.823 19.2758 4.823H5.6483C5.17014 4.823 4.81152 5.21003 4.81152 5.65661C4.81152 6.1032 5.17014 6.49023 5.6483 6.49023Z"
                          fill="#265D91" />
                        <path
                          d="M5.6483 11.2834H19.2758C19.7539 11.2834 20.1125 10.8964 20.1125 10.4498C20.1125 10.0032 19.724 9.61621 19.2758 9.61621H5.6483C5.17014 9.61621 4.81152 10.0032 4.81152 10.4498C4.81152 10.8964 5.17014 11.2834 5.6483 11.2834Z"
                          fill="#265D91" />
                        <path
                          d="M27.8526 25.1276L25.671 20.5129C26.0596 19.7984 26.2687 18.9648 26.2687 18.1014C26.2687 16.7617 25.7607 15.541 24.9239 14.6181V2.56039C24.9239 1.16111 23.7584 0 22.3538 0H2.57009C1.13562 0 0 1.16111 0 2.56039V18.3693C0 19.7984 1.16551 20.9297 2.57009 20.9297H16.2872L14.3148 25.1276C14.1056 25.5444 14.1654 26.0505 14.4642 26.4376C14.7631 26.8246 15.2413 26.9735 15.6895 26.9139L16.7654 26.7055L17.3033 27.6582C17.5125 28.0453 17.9309 28.2834 18.409 28.2834H18.4389C18.9171 28.2834 19.3355 27.9857 19.5447 27.5689L21.1286 24.2344L22.6527 27.5689C22.8619 27.9857 23.2803 28.2834 23.7584 28.2834H23.8182C24.2665 28.2834 24.6849 28.0453 24.9239 27.6582L25.432 26.7055L26.5078 26.9139C26.986 27.0032 27.4343 26.8246 27.7331 26.4376C28.0021 26.0505 28.0618 25.5444 27.8526 25.1276ZM21.0688 21.5847C19.1562 21.5847 17.5723 20.0068 17.5723 18.0716C17.5723 16.1364 19.1562 14.5585 21.0987 14.5585C23.0412 14.5585 24.6251 16.1364 24.6251 18.0716C24.5952 20.0068 23.0113 21.5847 21.0688 21.5847ZM1.67355 18.3693V2.56039C1.67355 2.08404 2.09194 1.66723 2.57009 1.66723H22.3538C22.832 1.66723 23.2504 2.05427 23.2504 2.56039V13.3676C22.5929 13.0699 21.8458 12.8913 21.0688 12.8913C19.6343 12.8913 18.3194 13.4867 17.3631 14.4394H5.64823C5.17007 14.4394 4.81145 14.8265 4.81145 15.2731C4.81145 15.7196 5.19996 16.1067 5.64823 16.1067H16.2872C16.0481 16.7021 15.8987 17.3869 15.8987 18.0716C15.8987 18.4884 15.9585 18.8755 16.0481 19.2327H2.59998C2.09194 19.2625 1.67355 18.8457 1.67355 18.3693ZM18.3493 26.1101L18.0803 25.6337C17.8711 25.2169 17.4228 24.9787 16.9746 24.9787C16.8849 24.9787 16.8251 24.9787 16.7355 25.0085L16.1976 25.0978L17.6619 21.9718C18.2596 22.5077 18.9769 22.8649 19.7539 23.0733L18.3493 26.1101ZM25.432 25.0085C24.894 24.9192 24.3561 25.1574 24.0872 25.6337L23.8182 26.1101L22.4136 23.0733C23.1906 22.8649 23.9078 22.4779 24.5055 21.942L25.9699 25.068L25.432 25.0085Z"
                          fill="#265D91" />
                      </svg>

                      CERTIFICATIONS
                    </button>
                  </h2>
                  <div id="kt_accordion_1_body_5" class="accordion-collapse collapse"
                    aria-labelledby="kt_accordion_1_header_5" data-bs-parent="#kt_accordion_1">
                    <div class="accordion-body">
                      <div>
                        <div class="formations table-certif mb-10">
                          <div class="responsive-table" formArrayName="certificat">
                            <table class="table align-middle style-table gy-5" id="kt_customers_table" style="box-shadow:none;">
                              <thead class="text-uppercase gs-0 fw-bold">
                                <th class="min-w-125px" style="white-space: nowrap;">Année</th>
                                <th class="min-w-125px required">
                                  Nom de la certification
                                </th>
                                <th class="min-w-125px" style="white-space: nowrap;">Compétences</th>
                                <th class="min-w-125px" style="white-space: nowrap;">ANNÉE D’EXPIRATION</th>
                                <th class="min-w-90px" style="white-space: nowrap;">Actions</th>
                              </thead>
                              <tbody  >
                                <tr *ngFor="
                                let certificate of certificatsControls;
                                let i = index" [formGroupName]="i"> 
                                  <td>
                                   <div class="height-certif">
                                    <p-calendar [style]="{'border': 'none','margin-top': '-6px'}"  view="year"  dateFormat="yy" placeholder="Année" inputId="yearpicker" formControlName="date"
                                    (ngModelChange)="selectDate1(i);selectDate2(i)" (input)="onInput($event)" class="form-control"></p-calendar>

                                    <div *ngIf="submittedCertificats[i]">
                                      

                                      <!-- <div
                                      *ngIf="
                                        candidateForm
                                          .get('certificat.' + i + '.date')
                                          ?.hasError('required') || 
                                        candidateForm.get(
                                          'certificat.' + i + '.date'
                                        )?.touched
                                      "
                                      class="text-danger"
                                    >
                            <small *ngIf="candidateForm
                                      .get('certificat.' + i + '.date')
                                      ?.hasError('required')">
                                        Le champ  "Année" est
                                        obligatoire. 
                                      </small> 
                                    </div>
                                    -->

                                   
                                  </div> 
                                  <!-- <div *ngIf="isChosenDateValid2[i] && isfutur2[i]">
                                    <span style="color: red;"> La date de certification doit être antérieure à la date d’expiration.</span> 
                                  </div> -->
                                  <div *ngIf="!isChosenDateValid2[i] && isfutur2[i]">
                                    <p class="errDate">La date sélectionnée est dans le futur, il faut choisir une autre date</p>
                                  </div>
                                  
                                   </div>
                                  
                                  </td>
                                  <td>
                                   <div class="height-certif">
                                    <input type="text" name="certification" formControlName="name" id="certification"
                                    class="form-control" placeholder="Nom de la certification" /> 
                                    <div *ngIf="submittedCertificats[i]">
                                      
                                      <div
                                        *ngIf="
                                          candidateForm
                                            .get('certificat.' + i + '.name')
                                            ?.hasError('required') ||
                                          candidateForm.get(
                                            'certificat.' + i + '.name'
                                          )?.touched
                                        "
                                        class="text-danger"
                                      >
                                      <small *ngIf="candidateForm
                                      .get('certificat.' + i + '.name')
                                      ?.hasError('required')">

                                        Le champ "Nom de la Certification" est
                                        obligatoire. 

                                      </small> 

                                        
                                      </div>
                                    </div>
                                   </div>
                                  
                                  </td>
                                  <td>
                                    <div class="height-certif">
 <input type="text" name="Compétences" id="Compétences" class="form-control"
                                      placeholder="Compétences" formControlName="skills" />
                                      </div>
                                   
                                  </td>
                                  <td>
                                  <div class="height-certif">
                                    <p-calendar [style]="{'border': 'none','margin-top': '-6px'}"  view="year" dateFormat="yy" placeholder="Année" inputId="yearpicker" formControlName="end_date"
                                    (ngModelChange)="selectDate2(i)" (input)="onInput($event)" class="form-control"></p-calendar>
                                     <div
                                  *ngIf="
                                    candidateForm.get('certificat.' + i + '.end_date')?.hasError('invalidDate') &&
                                    candidateForm.get('certificat.' + i + '.end_date')?.touched
                                  "
                                  class="text-danger"
                                >
                                  Veuillez saisir une date à partir de 1900.
                                </div>
                                <div *ngIf="isChosenDateValid2[i] && isfutur2[i]">
                                  <span style="color: red;"> La date de certification doit être antérieure à la date d’expiration.</span> 
                                </div>
                                <div *ngIf="!isChosenDateValid3[i] && isfutur3[i]">
                                  <p class="errDate">La date sélectionnée est dans le futur, il faut choisir une autre date</p>
                                </div>
                                  </div>
                                    
                               
                                  </td>
                                  <td>
                                    <div class="actions" style="margin-top: -20px;">
                                      <a (click)="removeCertificats(i)" class="delete">
                                        <svg width="20" height="23" viewBox="0 0 20 23" fill="none"
                                          xmlns="http://www.w3.org/2000/svg">
                                          <path
                                            d="M18.3004 5.0961H19.1502C19.3756 5.0961 19.5917 5.00657 19.7511 4.8472C19.9105 4.68784 20 4.47169 20 4.24631C20 4.02093 19.9105 3.80478 19.7511 3.64541C19.5917 3.48604 19.3756 3.39651 19.1502 3.39651H14.9012V2.54671C14.8992 1.87119 14.63 1.22391 14.1523 0.746244C13.6746 0.268576 13.0273 -0.000668049 12.3518 -0.00268555H7.25303C6.57751 -0.000668049 5.93023 0.268576 5.45256 0.746244C4.97489 1.22391 4.70565 1.87119 4.70363 2.54671V3.39651H0.849798C0.624418 3.39651 0.408268 3.48604 0.2489 3.64541C0.0895318 3.80478 0 4.02093 0 4.24631C0 4.47169 0.0895318 4.68784 0.2489 4.8472C0.408268 5.00657 0.624418 5.0961 0.849798 5.0961H1.30444V17.8431C1.30444 18.97 1.7521 20.0507 2.54894 20.8476C3.34578 21.6444 4.42653 22.0921 5.55343 22.0921H14.0514C15.1783 22.0921 16.2591 21.6444 17.0559 20.8476C17.8527 20.0507 18.3004 18.97 18.3004 17.8431V5.0961ZM8.10283 16.1435C8.10283 16.3689 8.01329 16.585 7.85393 16.7444C7.69456 16.9037 7.47841 16.9933 7.25303 16.9933C7.02765 16.9933 6.8115 16.9037 6.65213 16.7444C6.49276 16.585 6.40323 16.3689 6.40323 16.1435V9.34509C6.40323 9.11971 6.49276 8.90356 6.65213 8.7442C6.8115 8.58483 7.02765 8.4953 7.25303 8.4953C7.47841 8.4953 7.69456 8.58483 7.85393 8.7442C8.01329 8.90356 8.10283 9.11971 8.10283 9.34509V16.1435ZM13.2016 16.1435C13.2016 16.3689 13.1121 16.585 12.9527 16.7444C12.7933 16.9037 12.5772 16.9933 12.3518 16.9933C12.1264 16.9933 11.9103 16.9037 11.7509 16.7444C11.5915 16.585 11.502 16.3689 11.502 16.1435V9.34509C11.502 9.11971 11.5915 8.90356 11.7509 8.7442C11.9103 8.58483 12.1264 8.4953 12.3518 8.4953C12.5772 8.4953 12.7933 8.58483 12.9527 8.7442C13.1121 8.90356 13.2016 9.11971 13.2016 9.34509V16.1435ZM13.2016 3.39651H6.40323V2.54671C6.40323 2.32133 6.49276 2.10518 6.65213 1.94581C6.8115 1.78644 7.02765 1.69691 7.25303 1.69691H12.3518C12.5772 1.69691 12.7933 1.78644 12.9527 1.94581C13.1121 2.10518 13.2016 2.32133 13.2016 2.54671V3.39651Z"
                                            fill="#EE6352" />
                                        </svg>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="add-row">
                          <button class="add-diplome" (click)="addCertificats()">
                            + Ajouter
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="accordion-item">
                  <h2 class="accordion-header" id="kt_accordion_1_header_6">
                    <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#kt_accordion_1_body_6" aria-expanded="false"
                      aria-controls="kt_accordion_1_body_6">
                     <img src="/assets/media/logos/langue.svg" alt="">
                      LANGUES
                    </button>
                  </h2>
                  <div id="kt_accordion_1_body_6" class="accordion-collapse collapse"
                    aria-labelledby="kt_accordion_1_header_6" data-bs-parent="#kt_accordion_1">
                    <div class="accordion-body">
                      <div class="responsive" formArrayName="langue_user">
                        <table class="table" style="box-shadow: none !important">
                          <thead>
                            <th>
                              <span class="required">Langue</span>
                            </th>
                            <th><span class="required">Niveau</span></th>
                            <th><span class="required">Action</span></th>
                          </thead>
                          <tbody>
                            <tr
                              [formGroupName]="i"
                              *ngFor="
                                let langue of languesControls;
                                let i = index
                              "
                            >
                              <td>
                                <ng-select

                                  #selectComponent
                                  [items]="languages"
                                  bindLabel="name"
                                  class="ngSelectLanguge"
                                  bindValue="name"
                                  id="langue"
                                  placeholder="Langues"
                                  formControlName="name"
                                  (search)="onSearch($event)"
                                  [items]="
                                    languages
                                      | searchFilter : searchTerm : 'name'
                                  "
                                  [notFoundText]="'Aucun élément trouvé'"
                                  [typeahead]="searchLang$"
                                  (change)="validateLanguages($event)">                                >
                                </ng-select>

                                <div *ngIf="submittedLanguages[i]"> 
                                <div
                                  *ngIf="
                                    candidateForm.get(
                                      'langue_user.' + i + '.name'
                                    )?.invalid ||
                                    candidateForm.get(
                                      'langue_user.' + i + '.name'
                                    )?.touched
                                  "
                                  class="text-danger"
                                >
                                 
                                  <small *ngIf="candidateForm
                                  .get('langue_user.' + i + '.name')
                                  ?.hasError('required')">

                                    Le champ "Langage" est
                                    obligatoire. 

                                  </small> 
                                  
                                </div>
                                </div>
                              </td>
                              <td>
                                <div class="stars">
                                  <i
                                    class="fa fa-star"
                                    [ngClass]="{
                                      'star-filled':
                                        langue.get('stars')?.value >= 1
                                    }"
                                    (click)="setStars(langue, 1)"
                                    [class.gold]="
                                      langue.get('stars')?.value >= 1
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-star"
                                    [ngClass]="{
                                      'star-filled':
                                        langue.get('stars')?.value >= 2
                                    }"
                                    (click)="setStars(langue, 2)"
                                    [class.gold]="
                                      langue.get('stars')?.value >= 2
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-star"
                                    [ngClass]="{
                                      'star-filled':
                                        langue.get('stars')?.value >= 3
                                    }"
                                    (click)="setStars(langue, 3)"
                                    [class.gold]="
                                      langue.get('stars')?.value >= 3
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-star"
                                    [ngClass]="{
                                      'star-filled':
                                        langue.get('stars')?.value >= 4
                                    }"
                                    (click)="setStars(langue, 4)"
                                    [class.gold]="
                                      langue.get('stars')?.value >= 4
                                    "
                                  ></i>
                                  <i
                                    class="fa fa-star"
                                    [ngClass]="{
                                      'star-filled':
                                        langue.get('stars')?.value >= 5
                                    }"
                                    (click)="setStars(langue, 5)"
                                    [class.gold]="
                                      langue.get('stars')?.value >= 5
                                    "
                                  ></i>
                                </div>
                              </td>

                              <td>
                                <div class="actions">
                                  <a (click)="removeLangue(i,langue)" class="delete">
                                    <svg
                                      width="20"
                                      height="23"
                                      viewBox="0 0 20 23"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M18.3004 5.0961H19.1502C19.3756 5.0961 19.5917 5.00657 19.7511 4.8472C19.9105 4.68784 20 4.47169 20 4.24631C20 4.02093 19.9105 3.80478 19.7511 3.64541C19.5917 3.48604 19.3756 3.39651 19.1502 3.39651H14.9012V2.54671C14.8992 1.87119 14.63 1.22391 14.1523 0.746244C13.6746 0.268576 13.0273 -0.000668049 12.3518 -0.00268555H7.25303C6.57751 -0.000668049 5.93023 0.268576 5.45256 0.746244C4.97489 1.22391 4.70565 1.87119 4.70363 2.54671V3.39651H0.849798C0.624418 3.39651 0.408268 3.48604 0.2489 3.64541C0.0895318 3.80478 0 4.02093 0 4.24631C0 4.47169 0.0895318 4.68784 0.2489 4.8472C0.408268 5.00657 0.624418 5.0961 0.849798 5.0961H1.30444V17.8431C1.30444 18.97 1.7521 20.0507 2.54894 20.8476C3.34578 21.6444 4.42653 22.0921 5.55343 22.0921H14.0514C15.1783 22.0921 16.2591 21.6444 17.0559 20.8476C17.8527 20.0507 18.3004 18.97 18.3004 17.8431V5.0961ZM8.10283 16.1435C8.10283 16.3689 8.01329 16.585 7.85393 16.7444C7.69456 16.9037 7.47841 16.9933 7.25303 16.9933C7.02765 16.9933 6.8115 16.9037 6.65213 16.7444C6.49276 16.585 6.40323 16.3689 6.40323 16.1435V9.34509C6.40323 9.11971 6.49276 8.90356 6.65213 8.7442C6.8115 8.58483 7.02765 8.4953 7.25303 8.4953C7.47841 8.4953 7.69456 8.58483 7.85393 8.7442C8.01329 8.90356 8.10283 9.11971 8.10283 9.34509V16.1435ZM13.2016 16.1435C13.2016 16.3689 13.1121 16.585 12.9527 16.7444C12.7933 16.9037 12.5772 16.9933 12.3518 16.9933C12.1264 16.9933 11.9103 16.9037 11.7509 16.7444C11.5915 16.585 11.502 16.3689 11.502 16.1435V9.34509C11.502 9.11971 11.5915 8.90356 11.7509 8.7442C11.9103 8.58483 12.1264 8.4953 12.3518 8.4953C12.5772 8.4953 12.7933 8.58483 12.9527 8.7442C13.1121 8.90356 13.2016 9.11971 13.2016 9.34509V16.1435ZM13.2016 3.39651H6.40323V2.54671C6.40323 2.32133 6.49276 2.10518 6.65213 1.94581C6.8115 1.78644 7.02765 1.69691 7.25303 1.69691H12.3518C12.5772 1.69691 12.7933 1.78644 12.9527 1.94581C13.1121 2.10518 13.2016 2.32133 13.2016 2.54671V3.39651Z"
                                        fill="#EE6352"
                                      />
                                    </svg>
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                          <div *ngIf="
                              candidateForm
                                .get('langue_user')
                                ?.hasError('duplicateLanguage')">
                            <p class="errDate">
                              Vous ne pouvez pas ajouter deux langues avec le
                              même nom.
                            </p>
                          </div>
                        </table>
                      </div>
                      <div class="add-row">
                        <button class="add-diplome" (click)="addLangues()">
                          + Ajouter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="accordion-item">
                  <h2 class="accordion-header" id="kt_accordion_1_header_7">
                    <button class="accordion-button fw-semibold collapsed" type="button" data-bs-toggle="collapse"
                      data-bs-target="#kt_accordion_1_body_7" aria-expanded="false"
                      aria-controls="kt_accordion_1_body_7">
                      <svg width="30" height="26" viewBox="0 0 30 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M23.758 14.5011C20.7655 14.5011 18.3316 16.9431 18.3316 19.9443C18.3316 22.9455 20.7655 25.3876 23.758 25.3876C26.7505 25.3876 29.1843 22.9455 29.1843 19.9443C29.1843 16.9431 26.7505 14.5011 23.758 14.5011ZM23.758 24.2161C21.4104 24.2161 19.5001 22.3001 19.5001 19.9443C19.5001 17.5885 21.4104 15.6726 23.758 15.6726C26.1055 15.6726 28.0159 17.5885 28.0159 19.9443C28.0159 22.3001 26.1055 24.2161 23.758 24.2161Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                        <path
                          d="M23.7577 22.4731C24.0806 22.4731 24.3419 22.2106 24.3419 21.8874C24.3419 21.5642 24.0806 21.3016 23.7577 21.3016C23.4347 21.3016 23.1734 21.5642 23.1734 21.8874C23.1734 22.2106 23.4347 22.4731 23.7577 22.4731Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                        <path
                          d="M23.7577 17.4154C23.4345 17.4154 23.1734 17.6777 23.1734 18.0011V19.9441C23.1734 20.2675 23.4345 20.5299 23.7577 20.5299C24.0808 20.5299 24.3419 20.2675 24.3419 19.9441V18.0011C24.3419 17.6777 24.0808 17.4154 23.7577 17.4154Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                        <path
                          d="M17.9474 22.273H3.42106C2.67556 22.273 2.06843 21.6644 2.06843 20.9157V19.9442C2.06843 19.6208 1.80738 19.3585 1.48421 19.3585C1.16104 19.3585 0.9 19.6208 0.9 19.9442V20.9157C0.9 22.3098 2.03064 23.4445 3.42106 23.4445H17.9474C18.2706 23.4445 18.5317 23.1822 18.5317 22.8587C18.5317 22.5353 18.2706 22.273 17.9474 22.273Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                        <path
                          d="M2.06843 16.0582C2.06843 16.3817 1.80738 16.644 1.48421 16.644C1.16104 16.644 0.9 16.3817 0.9 16.0582V7.31475C0.9 5.92069 2.03064 4.786 3.42106 4.786H9.67624C9.96523 2.59983 11.8144 0.9 14.0737 0.9C16.3331 0.9 18.1822 2.59983 18.4712 4.786H24.7264C26.1168 4.786 27.2475 5.92069 27.2475 7.31475V14.1152C27.2475 14.4387 26.9864 14.701 26.6633 14.701C26.3401 14.701 26.0791 14.4387 26.0791 14.1152V12.3523C25.6887 12.6056 25.2269 12.758 24.7264 12.758H17.5632V15.0867C17.5632 15.3387 17.4026 15.5626 17.1639 15.6422L2.06843 16.0582ZM2.06843 16.0582V12.3523M2.06843 16.0582V12.3523M2.06843 12.3523C2.45882 12.6056 2.9206 12.758 3.42106 12.758H10.5843V15.0867C10.5843 15.3387 10.7449 15.5626 10.9835 15.6422L2.06843 12.3523ZM14.2587 16.6137L17.1639 15.6422H10.9836L13.8888 16.6137C13.9485 16.6337 14.0112 16.644 14.0737 16.644C14.1362 16.644 14.199 16.6337 14.2587 16.6137ZM11.7527 10.815H16.3948V14.6647L14.0737 15.441L11.7527 14.6647V10.815ZM14.0737 2.0715C15.688 2.0715 17.0352 3.24456 17.3113 4.786H10.8362C11.1123 3.24456 12.4594 2.0715 14.0737 2.0715ZM3.42106 5.9575H24.7264C25.4719 5.9575 26.0791 6.5661 26.0791 7.31475V10.2292C26.0791 10.9779 25.4719 11.5865 24.7264 11.5865H17.5632V10.815H17.9474C18.2706 10.815 18.5317 10.5527 18.5317 10.2292C18.5317 9.90582 18.2706 9.6435 17.9474 9.6435H10.2C9.87687 9.6435 9.61583 9.90582 9.61583 10.2292C9.61583 10.5527 9.87687 10.815 10.2 10.815H10.5843V11.5865H3.42106C2.67556 11.5865 2.06843 10.9779 2.06843 10.2292V7.31475C2.06843 6.5661 2.67556 5.9575 3.42106 5.9575Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                        <path
                          d="M1.48421 18.5869C1.80716 18.5869 2.06843 18.3243 2.06843 18.0011C2.06843 17.6779 1.80716 17.4154 1.48421 17.4154C1.16126 17.4154 0.9 17.6779 0.9 18.0011C0.9 18.3243 1.16126 18.5869 1.48421 18.5869Z"
                          fill="#265D91" stroke="#265D91" stroke-width="0.2" />
                      </svg>

                      EXPÉRIENCES PROFESSIONNELLES
                    </button>
                  </h2>
                  <div id="kt_accordion_1_body_7" class="accordion-collapse collapse"
                  aria-labelledby="kt_accordion_1_header_7" data-bs-parent="#kt_accordion_1">
                  <div class="accordion-body" formArrayName="prof_experience">
                    <div class="content" *ngFor="
                        let experience of experiencesControls;
                        let i = index
                      ">
                      <div class="professionel mb-10 mt-10" [formGroupName]="i" >
                        <div class="section">
                          <div class="row">
                            <div class="col-11">
                              <label for="poste" class="required">Poste/Fonction</label>
                            </div>
                            <div class="delete">
                              <a
                                (click)="removeExperiences(i)"
                                class="deleteExperience"
                              >
                                <svg
                                  width="20"
                                  height="23"
                                  viewBox="0 0 20 23"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M18.3004 5.0961H19.1502C19.3756 5.0961 19.5917 5.00657 19.7511 4.8472C19.9105 4.68784 20 4.47169 20 4.24631C20 4.02093 19.9105 3.80478 19.7511 3.64541C19.5917 3.48604 19.3756 3.39651 19.1502 3.39651H14.9012V2.54671C14.8992 1.87119 14.63 1.22391 14.1523 0.746244C13.6746 0.268576 13.0273 -0.000668049 12.3518 -0.00268555H7.25303C6.57751 -0.000668049 5.93023 0.268576 5.45256 0.746244C4.97489 1.22391 4.70565 1.87119 4.70363 2.54671V3.39651H0.849798C0.624418 3.39651 0.408268 3.48604 0.2489 3.64541C0.0895318 3.80478 0 4.02093 0 4.24631C0 4.47169 0.0895318 4.68784 0.2489 4.8472C0.408268 5.00657 0.624418 5.0961 0.849798 5.0961H1.30444V17.8431C1.30444 18.97 1.7521 20.0507 2.54894 20.8476C3.34578 21.6444 4.42653 22.0921 5.55343 22.0921H14.0514C15.1783 22.0921 16.2591 21.6444 17.0559 20.8476C17.8527 20.0507 18.3004 18.97 18.3004 17.8431V5.0961ZM8.10283 16.1435C8.10283 16.3689 8.01329 16.585 7.85393 16.7444C7.69456 16.9037 7.47841 16.9933 7.25303 16.9933C7.02765 16.9933 6.8115 16.9037 6.65213 16.7444C6.49276 16.585 6.40323 16.3689 6.40323 16.1435V9.34509C6.40323 9.11971 6.49276 8.90356 6.65213 8.7442C6.8115 8.58483 7.02765 8.4953 7.25303 8.4953C7.47841 8.4953 7.69456 8.58483 7.85393 8.7442C8.01329 8.90356 8.10283 9.11971 8.10283 9.34509V16.1435ZM13.2016 16.1435C13.2016 16.3689 13.1121 16.585 12.9527 16.7444C12.7933 16.9037 12.5772 16.9933 12.3518 16.9933C12.1264 16.9933 11.9103 16.9037 11.7509 16.7444C11.5915 16.585 11.502 16.3689 11.502 16.1435V9.34509C11.502 9.11971 11.5915 8.90356 11.7509 8.7442C11.9103 8.58483 12.1264 8.4953 12.3518 8.4953C12.5772 8.4953 12.7933 8.58483 12.9527 8.7442C13.1121 8.90356 13.2016 9.11971 13.2016 9.34509V16.1435ZM13.2016 3.39651H6.40323V2.54671C6.40323 2.32133 6.49276 2.10518 6.65213 1.94581C6.8115 1.78644 7.02765 1.69691 7.25303 1.69691H12.3518C12.5772 1.69691 12.7933 1.78644 12.9527 1.94581C13.1121 2.10518 13.2016 2.32133 13.2016 2.54671V3.39651Z"
                                    fill="#EE6352"
                                  />
                                </svg>
                              </a>
                            </div>

                          </div>

                          <input type="text" name="poste" id="poste" class="form-control form-control-experience"
                            placeholder="Poste" formControlName="poste" />
                          <div *ngIf="candidateForm.get('prof_experience.' + i + '.poste')?.invalid && candidateForm.get('prof_experience.' + i + '.poste')?.touched">
                            <div *ngIf="candidateForm.get('prof_experience.' + i + '.poste')?.hasError('required') && candidateForm.get('prof_experience.' + i + '.poste')?.touched"
                                        class="text-danger">
                                      Le champ "Poste" est obligatoire.
                                    </div>
                          </div>

                          <div class="d-flex flex-stack py-3">
                            <div class="details-poste rotate collapsible" data-bs-toggle="collapse" [attr.href]="'#kt_user_view_details_'+i" role="button" aria-expanded="false" [attr.aria-controls]="'kt_user_view_details_'+i">
                                Plus de Détails
                                <span class="ms-2 rotate-180">
                                    <i class="ki-duotone ki-down fs-3"></i>
                                </span>
                            </div>
                        </div>
                        <div [attr.id]="'kt_user_view_details_'+i"  class="collapse">
                          <div class="pb-5">
                            <div class="mb-10">
                              <div class="row">
                                <div class="col-lg-4">
                                  <label for="Période" class="required" >Date de début</label>
                                
                                    <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy" placeholder="Date de début"
                                    [maxDate]="today"
                                    inputId="yearpicker" formControlName="start_date"
                                    (ngModelChange)="calculatePeriod(i,experience.get('current_position')?.value =='1' ? true : checkeddatefin[i]);selectDate3(i)" (input)="onInput($event)"class="form-control"></p-calendar>
                                    <div *ngIf="candidateForm.get('prof_experience.' + i + '.start_date')?.hasError('required') && candidateForm.get('prof_experience.' + i + '.start_date')?.touched"
                                    class="text-danger">
                                  Le champ "Date de début" est obligatoire.
                                  </div>
                                    
                           
                    
                
                                    <div *ngIf="
                                      ExperienceForm.get('start_date')?.hasError(
                                        'invalidDate'
                                      )
                                    ">
                                 
                                  </div>
                                 
                                </div>
                                <div class="col-lg-4">
                                  <label for="Période">Date de fin</label>
                                    <p-calendar [style]="{'border': 'none','margin-top': '-6px'}" dateFormat="dd/mm/yy" placeholder="Date de fin" inputId="yearpicker"
                                    [minDate]="experience.get('start_date')?.value || today"
                                    formControlName="end_date"
                                    (ngModelChange)="calculatePeriod(i,experience.get('current_position')?.value =='1' ? true : checkeddatefin[i])" (input)="onInput($event)" class="form-control"  [ngClass]="{'disabled-date': experience.get('current_position')?.value =='1' ? true : checkeddatefin[i]}"></p-calendar>
                                </div>
                        
                              <div class="col-lg-4 form-check checkExperiance">
                                <input type="checkbox" class="form-check-input" id="current_position_{{i}}" formControlName="current_position" (change)="onCurrentPositionChange(i,$event)" 
                                />
                                <label class="form-check-label" for="current_position_{{i}}">
                                  Mon poste actuel
                                </label>
                              </div>
                           
                              </div>
                              <div>
                                <p class="nombre" >
                                  Période: {{ experience.get('period')?.value }}
                                </p>
                               
                              </div>
                            </div>
    
                            <div class="mb-10">
                              <label for="Client">Client</label>
                              <input type="text" name="client" id="client" class="form-control form-control-experience"
                                placeholder="Client" formControlName="client" />
                            </div>
                            <div class="mb-10">
                              <label for="Client">Projet</label>
                              <input type="text" name="project" id="project" class="form-control form-control-experience"
                                formControlName="project" placeholder="projet" />
                            </div>
                           
                            <div class="mb-10" style="display: inline-block;width: 100%;">
                              <label for="Client">Descriptif</label>
                             
                                <quill-editor formControlName="description" placeholder="Descriptif" [modules]="toolbarOptions"
                                style="width: 95%; height: 100%; display: 
                                
                                block;border-radius: 8px;
    border: 1px solid #265D91;"></quill-editor>
                            </div>
                            <div class="mb-10">
                              <label for="Méthodes">Méthodes</label>
                              <input type="text" name="equipe" id="Méthodes" class="form-control form-control-experience"
                                formControlName="method" placeholder="Agile/Scrum" />
                            </div>
                            <div class="mb-10">
                              <label for="Client">Tâches</label>
                              <textarea name="desc" id="Tâches" class="form-control form-control-experience"
                                style="height: 120px" formControlName="tasks"></textarea>
                            </div>
                            <div class="mb-10">
                              <label for="Outils">Outils / Technologies </label>
                              <input type="text" name="Outils" id="Outils" class="form-control form-control-experience"
                                placeholder="Js/React/Typescript ..." formControlName="technologies" />
                            </div>
                          </div>
                      </div>

                        </div>
                       
                      </div>
                      <hr />
                    </div>
                  </div>
                  <!--begin::Accordion-->
                  <div class="add-row">
                    <button class="add-diplome" (click)="addExperiences()">
                      + Ajouter Expérience
                    </button>
                  </div>
                  <!--end::Accordion-->
                </div>
                </div>
              </div>

              <div class="row mt-10">
                <div class="col-lg-4"></div>
                <div class="col-lg-4"></div>
                <div class="col-lg-4">
                  <div class="actions-profil">
                    <button
                      type="submit"
                      class="saving"
                      (click)="onSubmit()"
                     
                    >
                      Enregistrer
                    </button>
                    <!-- [disabled]="!candidateForm.valid" -->
                  </div>
                </div>
              </div>
            </div>
            <!--end::Accordion-->
            <!--end::Card header-->
            <!--begin::Card body-->
            <!--end::Card body-->
          </div>
        </form> 
        
      </div>
    </div>
  </div>
</div>
